import type { TranslationKeys } from "../types/translation";

export const esTranslations: TranslationKeys = {
  // Common
  common: {
    done: "Listo",
    loading: "Cargando...",
    error: "Error",
    retry: "Reintentar",
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    add: "Agregar",
    search: "Buscar",
    filter: "Filtrar",
    close: "Cerrar",
    back: "Atrás",
    next: "Siguiente",
    previous: "Anterior",
    continue: "Continuar",
    submit: "Enviar",
    welcome: "Bienvenido",
    logout: "Cerrar sesión",
    login: "Iniciar sesión",
    signup: "Registrarse",
    register: "Registrarse",
    getStarted: "Empezar",
    settings: "Ajustes / Pagos",
    help: "Ayuda",
    support: "Soporte",
    admin: "Administrador",
    yes: "Sí",
    no: "No",
    ok: "Aceptar",
    apply: "Aplicar",
    reset: "Restablecer",
    clear: "Limpiar",
    all: "Todos",
    none: "Ninguno",
    select: "Seleccionar",
    confirm: "Confirmar",
    howItWorks: "Cómo funciona",
    noDataFound: "No se encontraron datos",
    tryAdjustingFilters: "Intenta ajustar tus filtros",
    somethingWentWrong: "Algo salió mal",
    tryAgain: "Intentar de nuevo",
    store: "Tienda",
    category: "Categoría",
    loadingCategories: "Cargando categorías...",
    allCategories: "Todas las categorías",
    noCategoriesFound: "No se encontraron categorías",
    more: "Más",
    searching: "Buscando...",
    searchingMessage: "Esto puede tomar hasta 30 segundos...",
    contactUs: "Contáctanos",
  },

  // Navigation
  nav: {
    products: "Productos",
    productSearch: "Búsqueda",
    myFavorites: "Guardados",
    productTracking: "Alertas de productos",
    configuration: "Filtros de compra",
    helpSupport: "Ayuda y soporte",
    discord: "Discord",
    linkDiscord: "Enlazar Discord",
    pennyMealsMemberTitle: "Penny Meals viene incluido con tu plan",
    pennyMealsMemberBody: "Cenas baratas con las rebajas del súper de esta semana. Entra con tu cuenta de DealHawk.",
    pennyMealsFreeTitle: "Prueba Penny Meals",
    pennyMealsFreeBody: "Convierte las rebajas del súper cerca de ti en cenas baratas. Viene incluido con cualquier plan de DealHawk.",
    pennyMealsShort: "Penny Meals",
    pennyMealsSidebarMember: "Incluido con tu plan",
    pennyMealsSidebarFree: "Cenas baratas con rebajas cerca de ti",
    pennyMealsDismiss: "Ocultar la tarjeta de Penny Meals",
    chromeExtension: "Extensión de Chrome",
    menu: "Menú",
    catalog: "Catálogo",
    allCategories: "Todas las categorías",
    allStores: "Todas las Tiendas",
    viewAllProducts: "Ver todos los productos",
    lookingForDeals: "Buscando ofertas",
    store: "Tienda",
  },

  // Auth
  auth: {
    welcomeBack: "Bienvenido de vuelta a DealHawk",
    signUpMessage: "¿No tienes una cuenta?",
    loginHere: "Inicia sesión aquí",
    signUpHere: "Regístrate aquí",
    dontHaveAccount: "¿No tienes una cuenta?",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    email: "Correo electrónico",
    password: "Contraseña",
    confirmPassword: "Confirmar contraseña",
    name: "Nombre",
    forgotPassword: "¿Olvidaste tu contraseña?",
    rememberMe: "Recordarme",
    createAccount: "Crear cuenta",
    joinDealHawk: "Únete a DealHawk",
    signinButton: "Iniciar sesión",
    registerButton: "Registrarse",
    emailPlaceholder: "Ingresa tu dirección de correo electrónico",
    passwordPlaceholder: "Ingresa tu contraseña",
    namePlaceholder: "Ingresa tu nombre completo",
    confirmPasswordPlaceholder: "Confirma tu contraseña",
    verifyEmail: "Verifica tu correo electrónico",
    verificationCode: "Código de verificación",
    verificationCodeSent:
      "Hemos enviado un código de verificación a tu dirección de correo electrónico",
    checkYourInbox: "Revisa tu correo",
    weSentACodeTo: "Enviamos un código a",
    didntGetIt: "¿No lo recibiste?",
    wrongAccount: "¿Correo equivocado?",
    signOut: "Cerrar sesión",
    backToLogin: "Volver al inicio de sesión",
    didntReceiveCode: "¿No recibiste el código?",
    resendCode: "Reenviar código",
    resendSuccess: "Enviamos un nuevo código a tu correo.",
    resendError: "No pudimos enviar un nuevo código. Inténtalo de nuevo en un momento.",
    sending: "Enviando...",
    termsAgreement: "Al iniciar sesión, aceptas nuestros",
    termsOfService: "Términos de Servicio",
    and: "y",
    privacyPolicy: "Política de Privacidad",
    orSignInWith: "o inicia sesión con",
    continueWithGoogle: "Continuar con Google",
    continueWithDiscord: "Continuar con Discord",
    needHelp: "¿Necesitas ayuda?",
    contactSupport: "Contactar Soporte",
    passwordsDoNotMatch: "Las contraseñas no coinciden",
    agreeToThe: "Acepto los",
    bySigningUpYouAgree: "Al registrarte, aceptas nuestros",
    orSignUpWith: "o regístrate con",
    // Unified auth flow
    unifiedTitle: "Bienvenido a DealHawk",
    headline: "Llega primero a las ofertas",
    or: "o",
    emailAddressPlaceholder: "Correo electrónico",
    newMemberOffer: "Los miembros nuevos obtienen 50% de descuento en su primer mes.",
    unifiedSubtitle: "Ingresa tu correo para iniciar sesión o crear una cuenta.",
    continueWithEmail: "Continuar con correo",
    enterPassword: "Ingresa tu contraseña",
    enterPasswordSubtitle: "Bienvenido de nuevo, {{email}}.",
    createPassword: "Crea una contraseña",
    createPasswordSubtitle:
      "Parece que eres nuevo — vamos a configurarte, {{email}}.",
    minCharacters: "Mínimo 8 caracteres",
    differentEmail: "Usar otro correo",
    checking: "Comprobando...",
    creatingAccount: "Creando cuenta...",
    iAgreeToCreate:
      "Acepto los {{terms}} y la {{privacy}} y deseo crear mi cuenta de DealHawk.",
    marketingEmailsConsent: "Envíame por correo ofertas de mis tiendas y promociones. Puedes darte de baja cuando quieras.",
  },

  // Landing Page
  landing: {
    // Landing v6: Fetch/Ibotta-style reseller page
    v6NavHow: "Cómo funciona",
    v6NavStores: "Tiendas",
    v6HeroLine1: "Convierte liquidaciones",
    v6HeroLine2: "en dinero.",
    v6HeroSub: "Encuentra liquidaciones y pennies en tiendas cerca de ti, y mira en cuánto se revenden.",
    v6StatRating: "en la App Store",
    v6StatPrices: "precios de tienda revisados al día",
    v6StatPennies: "pennies detectados",
    v6DealsTitle: "Encontrado esta semana.",
    v6DealsSub: "Hallazgos recientes de la pestaña Leads de la app.",
    v6FlipsTitle: "En cuánto se revende un penny.",
    v6FlipsSub: "Artículos marcados como posibles pennies en tiendas grandes ahora mismo, y en cuánto se vendieron en eBay.",
    v6SellsFor: "se vende en {{price}} en eBay",
    v6SoldCount: "{{count}} vendidos · antes {{reg}}",
    v6FlipsNote: "Los precios de penny no están garantizados hasta pasar por caja. Los precios de eBay son medianas de ventas recientes.",
    v6AltMakitaBattery: "Kit de batería Makita 40V XGT 4.0Ah con cargador",
    v6AltRyobiWrench: "Llave de impacto compacta RYOBI ONE+ HP 18V de 3/8 in.",
    v6AltMakitaSaw: "Sierra recíproca Makita 40V XGT sin escobillas",
    v6AltWeber: "Parrilla portátil de gas Weber Traveler",
    v6GetStarted: "Empezar",
    v6BigBox: "Tienda grande",
    v6AltBose: "Audífonos Bose QuietComfort",
    v6AltKitchenAid: "Batidora de pedestal KitchenAid Deluxe de 4.5 qt",
    v6AltBlackstone: "Plancha Blackstone de 28 in. y 2 quemadores",
    v6AltMilwaukeeBlower: "Sopladora Milwaukee M18 FUEL de doble batería",
    v6MoreRetailersCount: "30+",
    v6MoreRetailers: "tiendas más",
    v6AlertsAlt: "Alertas de precio de DealHawk: una Hoover a $187, debajo del objetivo de $199",
    v6FeedAlt: "DealHawk mostrando rebajas de Walmart con precio, unidades y pasillo",
    v6Step1Title: "Elige tus tiendas",
    v6Step1Text: "Las que ya te quedan de paso.",
    v6Step2Title: "Recibe las rebajas",
    v6Step2Text: "Precio, unidades, pasillo y en cuánto se revende.",
    v6Step3Title: "Revende y cobra",
    v6Step3Text: "Vende en Amazon, eBay o Marketplace.",
    v6StoresTitle: "Tiendas que vigilamos",
    v6StoresSub: "Precios del estante, no de la web.",
    v6HaulsTitle: "Miembros revendiendo ahora",
    v6AltJbl: "Bocinas JBL que un miembro compró a $99 cada una",
    v6AltShark: "Aspiradora Shark que un miembro compró a $89",
    v6AltCoolers: "Nueve coolers que un miembro compró al 70%",
    v6AltMilwaukee: "Un carrito de artículos Milwaukee que un miembro compró a un centavo",
    v6Each: "c/u",
    v6ReviewsTitle: "{{rating}} en la App Store.",
    v6SourceAppStore: "Reseña en la App Store",
    v6SourceDiscord: "Post de miembro · Discord de DealHawk",
    v6PostVacTitle: "Aspiradora de $549 por $89",
    v6PostPennyTitle: "Primeros pennies",
    v6ReviewAppTr: "¡Una app de verdad, súper fácil de usar! ¡Me encanta! ¡Ahí voy por las ofertas!",
    v6ReviewMejorTr: "Tu mejor aliada para descubrir ofertas y liquidaciones.",
    v6PostVacTr: "Acabo de llevarme mi aspiradora de $549 por $89",
    v6PostPennyTr: "Me uní y en menos de una hora encontré mis primeros pennies.",
    v6HalfOff: "50% menos tu primer mes",
    v6PlansTitle: "Una reventa lo paga.",
    v6ThenPrice: "el primer mes, luego ${{price}}/mes",
    v6PlanStores: "{{stores}} tiendas + {{nearby}} cercanas",
    v6StartPlan: "Empezar {{plan}}",
    v6FinalLine1: "Mira las rebajas de hoy",
    v6FinalLine2: "en tus tiendas.",
    v6Disclaimer: "Sin afiliación con las tiendas mostradas. La ganancia es un estimado de la app; los resultados varían.",
    // Nav
    navFeatures: "Lo que obtienes",
    navHauls: "Hallazgos",
    navPricing: "Precios",
    navCta: "Iniciar sesión",
    navStart: "Comenzar",
    browseFreeDeals: "Explorar ofertas en línea gratis",

    // Hero
    promoBadge: "50% de descuento en tu primer mes",
    cancelAnytime: "cancela cuando quieras",
    heroBadge: "Más de 1,000,000 de rebajas encontradas esta semana",
    heroLine1: "Conoce las rebajas",
    heroLine2: "antes de salir.",
    heroSubtitle:
      "DealHawk te muestra el precio en vivo, el inventario, la tienda y el pasillo exacto antes de salir de casa.",
    heroCtaPrimary: "Encontrar ofertas cerca de mí",
    heroCtaSecondary: "Ver ofertas gratis",
    heroPlanNote: "Ofertas en línea gratis · Planes locales desde $17.50",
    videoProofTitle: "Cacerías reales. Estantes reales.",
    huntAirFryerTitle: "Freidora de aire portátil",
    huntAirFryerDetail: "$50 en Walmart · Pasillo I7",
    huntMicrowaveTitle: "Rebaja oculta en aspiradora",
    huntMicrowaveDetail: "$30 en Walmart",
    huntMonitorTitle: "Rebaja en monitor para juegos",
    huntMonitorDetail: "$74 en Walmart",
    huntTvTitle: "Rebaja en televisor",
    huntTvDetail: "Encontrado en el estante",
    huntAppTitle: "App de DealHawk",
    huntAppDetail: "La cacería empieza aquí",
    freshFindsTitle: "Hallazgos nuevos",
    freshFindsSubtitle: "Las mejores ofertas encontradas en las últimas 24 horas.",
    freshFindsBrowse: "Ver todas las ofertas",
    freshFindsOff: "menos",
    freshFindsJustAdded: "Recién agregado",
    freshFindsMinutesAgo: "Hace {{count}} min",
    freshFindsHoursAgo: "Hace {{count}} h",
    statSaved: "ahorrados este año",
    statMarkdown: "descuento promedio",
    statStores: "tiendas",
    retailersLabel: "Encontrando ofertas en",

    // What you get
    featuresLabel: "Lo que obtienes",
    featuresTitle: "Hecho para la caza.",
    feature1Title: "Liquidaciones en vivo",
    feature1Text:
      "Cada rebaja oculta en cada tienda cerca de ti, actualizada todo el día, incluyendo precios que el sitio web nunca muestra.",
    feature2Title: "Escanea y compara",
    feature2Text:
      "Escanea cualquier código de barras y ve al instante el precio y el inventario en cada tienda a tu alrededor, hasta el pasillo y el estante.",
    feature3Title: "Alertas de bajadas de precio",
    feature3Text:
      "Fija un precio objetivo para lo que sea. Tu teléfono vibra en cuanto baja. No vuelvas a refrescar una página de producto.",
    feature4Title: "Selección de la comunidad",
    feature4Text:
      "Los hallazgos más calientes que los miembros están comprando hoy, servidos en bandeja, ordenados por descuento y distancia.",

    // How it works
    howItWorksLabel: "Cómo funciona",
    howItWorksTitle:
      "Dos minutos para configurar. 24 horas para tu primer hallazgo.",
    step1Title: "Elige tus tiendas",
    step1Text:
      "Elige las tiendas por las que realmente pasas — Walmart, Target, Lowe's, Costco y más.",
    step2Title: "Recibe alertas",
    step2Text:
      "Vigilamos los precios todo el día y te avisamos en cuanto algo baja 80% o más.",
    step3Title: "Entra y ahorra",
    step3Text:
      "Las indicaciones por pasillo te llevan directo al estante, antes de que llegue la multitud.",

    // Member finds
    memberFindsLabel: "De miembros en todo el país",
    memberFindsTitle: "Recibos reales. Rebajas reales.",
    savedAmount: "Ahorró ${{amount}}",
    testimonial1:
      "La freidora de aire Ninja marcaba $199. Pasó a $38 en caja. La app la tenía antes de que la tienda cambiara la etiqueta.",
    testimonial2:
      "Encontré una batidora KitchenAid a $86, precio normal $349. Nunca hubiera pasado por ese pasillo.",
    testimonial3:
      "Dos televisores de 65 pulgadas a $150 cada uno, de $449. Un mes de la app se pagó solo unas cuarenta veces.",
    testimonial4:
      "Compré la aspiradora Shark a $60, y estaba en $299. Mi esposo no lo podía creer cuando vio el recibo.",
    testimonial5:
      "La lista de centavos salió un martes. $214 en cosas, pagué $0.19. La cajera llamó al gerente para que viera.",
    testimonial6:
      "Kit de taladro Kobalt a $39 en vez de $149. El mismo estante por el que pasé dos veces a precio completo.",

    // Pricing
    pricingLabel: "Precios",
    pricingTitle: "Un buen hallazgo paga el mes.",
    pricingSubtitle:
      "50% de descuento en tu primer mes en todos los planes. Cancela cuando quieras.",
    mostPopular: "Más popular",
    perMonth: "/mes",
    firstMonthThen: "Primer mes, luego ${{price}}/mes",
    startFindingDeals: "Empieza a encontrar ofertas",
    retailerDisclaimer:
      "DealHawk es un servicio independiente y no está afiliado, respaldado ni conectado oficialmente con ningún minorista presentado en la plataforma.",
    planBasicDesc: "Perfecto para empezar",
    planBasicF1: "1 Walmart + 1 tienda local de grandes superficies, cada una con 4 tiendas extra cercanas",
    planBasicF2: "Notificaciones push y alertas",
    planBasicF3: "Búsqueda de productos y leads",
    planBasicF4: "App móvil + acceso a la comunidad",
    planProDesc: "Para cazadores de ofertas serios",
    planProF1: "5 Walmart + 5 tiendas locales de grandes superficies, más 15 Walmart y 10 de grandes superficies extra cercanas",
    planProF2: "5 Target + 5 Dollar General + 5 Lowe's",
    planProF3: "3 tiendas Costco + herramientas locales avanzadas",
    planProF4: "Más ofertas guardadas + alertas de precio",
    planProF5: "Soporte prioritario",
    planPlusDesc: "Más tiendas, más ahorro",
    planPlusF1: "3 Walmart + 3 tiendas locales de grandes superficies, más 7 tiendas extra cercanas de cada una",
    planPlusF2: "2 Target + Lowe's, Costco y Best Buy",
    planPlusF3: "Más ofertas guardadas + alertas de precio",
    planPlusF4: "Todo lo incluido en Basic",

    // Landing: receipts, explained
    heroOffBadge: "50% de descuento",
    heroOffRest: "tu primer mes en cualquier plan",
    heroTitleLead: "Las liquidaciones en tienda cerca de ti,",
    heroTitleHighlight: "en vivo en tu teléfono.",
    heroLede: "Cada rebaja en las tiendas cerca de ti, con inventario y el pasillo exacto.",
    heroPlatforms: "iPhone, Android y web",
    heroCancel: "Cancela cuando quieras",
    heroAlertLabel: "Bajó de precio · ahora",
    heroAlertItem: "Freidora de aire",
    heroAlertDetail: "Pasillo I7 · quedan 5",
    heroPhoneAlt: "App de DealHawk con un refrigerador Frigidaire a $119, quedan 7 en el pasillo E7",
    receiptTitle: "Recibo de miembro",
    receiptItem: "Freidora Ninja",
    receiptTag: "Etiqueta",
    receiptPaid: "Pagado",
    receiptSaved: "Ahorró {{amount}}",
    shelfPricesFrom: "Precios de tienda en",
    storesOther: "Otras tiendas grandes",
    storesPenny: "Artículos de a centavo",
    appTitle: "Lo que tienes en la app.",
    appSubtitle: "Las tiendas bajan precios en tienda y nunca actualizan la web. Nosotros revisamos el estante.",
    appFeedTitle: "Ve cada rebaja",
    appFeedText: "Liquidaciones en vivo en tus tiendas.",
    appScanTitle: "Escanea cualquier código",
    appScanText: "Escanea un código de barras o pega un enlace. Ve precio, existencias y pasillo en cada tienda cercana.",
    appAlertTitle: "Entérate primero",
    appAlertText: "Pon un precio objetivo. Te avisamos cuando baje.",
    appAisleTitle: "Ve directo al pasillo",
    appAisleText: "Conoce el pasillo y cuántos quedan.",
    mockFeed1: "Ninja Foodi XL",
    mockFeed2: "Freidora portátil",
    mockFeed3: "Taladro Kobalt",
    mockScanItem: "Monitor gamer",
    mockScanStore: "Tienda #{{id}}",
    mockScanOnline: "En línea",
    mockAlertNow: "DealHawk · ahora",
    mockAlertTarget: "La aspiradora Shark llegó a tu precio:",
    mockAlertAgo: "DealHawk · hace 2 h",
    mockAlertNew: "3 rebajas nuevas en tu Target",
    mockAisle: "Pasillo I7",
    mockLeft: "Quedan 5",
    mockUpdated: "Actualizado hace 2 h",
    howTitleShort: "Configúralo en dos minutos.",
    howStep1Title: "Elige las tiendas por las que pasas",
    howStep1Text: "Walmart, Target, Lowe's, Costco y más.",
    howStep2Title: "Vigilamos los precios todo el día",
    howStep2Text: "Te avisamos cuando bajan.",
    howStep3Title: "Entra y llévatelo",
    howStep3Text: "Directo al pasillo.",
    findsTitle: "Lo que pagaron los miembros.",
    findsPrev: "Hallazgos anteriores",
    findsNext: "Más hallazgos",
    findsMemberPhoto: "Foto de miembro",
    findsMember: "Miembro de DealHawk",
    findsOff: "{{pct}}% menos",
    findTvItem: "TV de 65\"",
    findTvQuote: "Un mes de la app se pagó solo unas cuarenta veces.",
    findMixerItem: "Batidora KitchenAid",
    findMixerQuote: "Nunca hubiera pasado por ese pasillo.",
    findVacuumItem: "Aspiradora Shark",
    findVacuumQuote: "Mi esposo no lo podía creer cuando vio el recibo.",
    findDrillItem: "Taladro Kobalt",
    findDrillQuote: "El mismo estante por el que pasé dos veces a precio completo.",
    pricingShortSubtitle: "50% de descuento en tu primer mes. Cancela cuando quieras.",
    finalLead: "Tu próximo recibo podría ser",
    finalHighlight: "así de bueno.",

    // FAQ
    faqTitle: "Preguntas, respondidas.",
    faqSubtitle:
      "¿Aún tienes dudas? Pregunta a miles de cazadores en nuestro Discord.",
    faq1Q: "¿Cómo encuentra DealHawk ofertas que no están en línea?",
    faq1A:
      "Revisamos precios e inventario en tienda, incluso liquidaciones locales que nunca aparecen en línea.",
    faq2Q: "¿Es solo para revendedores?",
    faq2A:
      "No. La mayoría lo usa para ahorrar en lo que quiere. Algunos revenden.",
    faq3Q: "¿Qué minoristas están incluidos?",
    faq3A:
      "Walmart, Target, Dollar General, Costco, Best Buy, Lowe's, Amazon, Woot y ferreterías locales. Vienen más.",
    faq4Q: "¿Puedo cancelar en cualquier momento?",
    faq4A:
      "Sí. Sin contratos. Cancela desde tu cuenta cuando quieras.",

    // Final CTA
    ctaLine1: "Las ofertas ya están ahí afuera.",
    ctaLine2: "Ve por ellas.",
    ctaSubtitle: "50% de descuento el primer mes · cancela cuando quieras",
    ctaButton: "Empieza a ahorrar con 50% off",

    // Footer
    footerDescription:
      "DealHawk te ayuda a descubrir ofertas en tienda, rebajas de liquidación y diferencias de precio antes que nadie.",
    footerPrivacy: "Privacidad",
    footerTerms: "Términos",
    footerSupport: "Soporte",
    footerCopyright: "© {{year}} DealHawk",
    downloadOn: "Descargar en",
    appStore: "App Store",
    getItOn: "Disponible en",
    googlePlay: "Google Play",

    // Landing (Shotbase-style redesign)
    heroCtaOffer: "Empieza con 50% de descuento",
    navFreeDeals: "Ofertas gratis",
    navPenny: "Artículos de a centavo",
    heroHaulsBadge: "Compras reales de miembros",
    storesBigBox: "Grandes tiendas",
    appSheetLabel: "La app",
    appSheetTitle: "Encuéntralo. Revísalo. Llévatelo.",
    appSheetTitleMuted: "Sin adivinar.",
    liveClearanceTag: "Liquidación en vivo",
    liveClearanceTitle: "Cada rebaja en tus tiendas, en cuanto llega al estante",
    memberPaid: "Pagó un miembro",
    aisleBadge: "Pasillo I7",
    aisleLeft: "Quedan 5",
    heroRegularLabel: "Precio regular",
    heroRegularNote: "Lo que todavía cobran la web y casi todas las tiendas.",
    heroShelfLabel: "En el estante de una tienda cerca de ti",
    heroShelfOff: "75% de descuento",
    heroShelfUnits: "Quedan 7",
    heroShelfAisle: "Pasillo E7",
    heroGapLead: "Mismo refrigerador. Mismo día.",
    heroGapAmount: "$360.99 menos",
    heroGapRest: "en el pasillo.",
    navCommunity: "Comunidad",
    communityLabel: "Comunidad",
    communityTitle: "Cazar ofertas es mejor en compañía.",
    communityText: "Todos los planes de pago incluyen nuestro Discord. Los miembros comparten qué encontraron, dónde y cuánto pagaron, todo el día.",
    discordTag: "Discord para miembros",
    discordMember: "Miembro",
    discordToday: "Hoy",
    discordTyping: "Varios miembros están escribiendo…",
    discordCta: "Entra con cualquier plan de pago",
    appFeedAlt: "Lista de rebajas de DealHawk en una tienda Walmart",
    appScanAlt: "Búsqueda de DealHawk con precio y existencias en seis tiendas cercanas",
    appAlertAlt: "Alertas de precio de DealHawk que llegaron a su objetivo",
    discordCatDeals: "OFERTAS",
    discordCatHelp: "AYUDA",
    discordTopic: "Comparte tus compras. Precio, tienda, foto.",
    discordInput: "Mensaje en #member-finds",
    discordPerk1Title: "Canales solo para miembros",
    discordPerk1Text: "Hallazgos, artículos de a centavo, consejos",
    discordPerk2Title: "Alertas por mensaje de Discord",
    discordPerk2Text: "Cuando llega tu precio objetivo",
    discordPerk3Title: "Ayuda del equipo",
    discordPerk3Text: "Abre un ticket, 24/7",
    pennyLabel: "Artículos de a centavo",
    pennyTitle: "Sí, un centavo. Los miembros los encuentran cada semana.",
    pennyText: "Algunas grandes tiendas marcan la liquidación a un centavo antes de sacarla del piso. DealHawk te avisa de los artículos de a centavo en tus tiendas para que llegues primero.",
    pennyHaul: "Compra de un miembro",
    pennyCta: "Encuentra artículos de a centavo cerca de ti",
    pennyVacuums: "15 aspiradoras a $0.01",
    pennyHoses: "35 cajas de mangueras a $0.01",
    pennyLadders: "Escaleras a $0.01",
    pennyFirePit: "Fogata a $0.01",
    pennyStainStriker: "Shark StainStriker a $0.01",
    pennyPliers: "Juegos de pinzas a $0.01",
    pennyMilwaukee: "Un carrito de Milwaukee a $0.01",
    shelfTitleLead: "Llega a la oferta",
    shelfTitleRest: "antes de que se acabe.",
    shelfText: "DealHawk sigue precios e inventario en las tiendas cerca de ti y te avisa en cuanto algo baja, incluida la liquidación que nunca aparece en línea.",
    appSectionWeb: "Web",
    haulsLabel: "A los miembros les encanta",
    haulsTitle: "Compras reales. Recibos reales.",
    haulNinjaItem: "Cafetera Ninja",
    haulNinjaQuote: "Alguien en mi grupo encontró esta cafetera Ninja de $249 a $18 gracias a la app de DealHawk.",
    haulStratosItem: "Aspiradora Shark",
    haulStratosQuote: "Acabo de recoger mi aspiradora de $549 por $89.",
    haulGriddleItem: "Plancha Blackstone",
    haulGriddleQuote: "Por tan solo $51, precio regular $227.",
    haulBackpacksItem: "Mochilas",
    haulBackpacksQuote: "Mochilas de $24.97 a solo $2.",
    haulWagonItem: "Carrito Step2",
    haulWagonQuote: "¡$10, antes $80!",
    haulCaroteItem: "Ollas Carote",
    haulCaroteQuote: "Carote al 70%, me traje las 7 que había.",
    haulCoolersItem: "Hieleras",
    haulCoolersQuote: "9 hieleras a $15, al 70%. Segunda tienda.",
    haulSharkItem: "Shark inalámbrica",
    haulSharkQuote: "Casa de campaña $35, Shark $69.",
    haulPctOff: "{{pct}}% de descuento",
    haulWas: "antes {{price}}",
    faq5Q: "¿Qué son los artículos de a centavo?",
    faq5A: "Algunas grandes tiendas marcan la liquidación a $0.01 justo antes de sacarla del piso. DealHawk te muestra los artículos de a centavo en tus tiendas para que llegues primero.",
  },

  // Settings
  settings: {
    title: "Configuración",
    description: "Administra la configuración y preferencias de tu cuenta",
    billing: "Facturación",
    notifications: "Notificaciones",
    appearance: "Apariencia",
    security: "Seguridad",
    currentPlan: "Plan actual",
    active: "Activo",
    upgradeOptions: "Opciones de actualización",
    popular: "Popular",
    upgradeToPrefix: "Actualizar a",
    cancelSubscription: "Cancelar suscripción",
    cancelSubscriptionDescription:
      "Cancelar terminará tu acceso a las funciones premium al final de tu período de facturación actual.",
    cancelSubscriptionButton: "Cancelar suscripción",
    discordNotifications: "Notificaciones de Discord",
    discordNotificationsDescription:
      "Recibe alertas de ofertas entregadas a tu servidor de Discord",
    discordLinked: "Cuenta de Discord Vinculada",
    discordLinkedDescription:
      "Tu cuenta de Discord está conectada y recibirás notificaciones por mensaje directo",
    discordNotLinked: "Cuenta de Discord No Vinculada",
    discordNotLinkedDescription:
      "Vincula tu cuenta de Discord para recibir notificaciones de ofertas por mensaje directo",
    linkDiscord: "Vincular Cuenta de Discord",
    unlinkDiscord: "Desvincular Cuenta de Discord",
    linking: "Vinculando...",
    unlinking: "Desvinculando...",
    discordLinkedSuccess: "¡Cuenta de Discord vinculada exitosamente!",
    discordUnlinkedSuccess: "¡Cuenta de Discord desvinculada exitosamente!",
    discordLinkError:
      "Error al vincular cuenta de Discord. Por favor intenta de nuevo.",
    discordUnlinkError:
      "Error al desvincular cuenta de Discord. Por favor intenta de nuevo.",
    discordUpgradeMessage:
      "Las notificaciones de Discord solo están disponibles para planes de pago. Actualiza para vincular tu cuenta de Discord y recibir alertas de ofertas.",
    viewPlans: "Ver Planes",
    themeSelection: "Selección de tema",
    themeSelectionDescription:
      "Elige tu tema de color preferido para la aplicación",
    applying: "Aplicando...",
    cancelReason: "Razón para cancelar",
    cancelReasonPlaceholder: "Por favor, dinos por qué estás cancelando...",
    keepSubscription: "Mantener suscripción",
    language: "Idioma",
    languageDescription: "Elige tu idioma preferido",
    selectLanguage: "Seleccionar idioma",
    english: "Inglés",
    spanish: "Español",
    loading: "Cargando...",
    processing: "Procesando...",
    perMonth: "/mes",
    discordAccess: "Acceso a Discord",
    store: "Tienda",
    stores: "Tiendas",
    allCategories: "Todas las categorías",
    limitedAccess: "Acceso limitado",
    basicFeatures: "Características básicas",
    noAccess: "Sin acceso a la plataforma",
    upgradeRequired: "Actualización requerida para usar características",
    upgradeToUnlock:
      "Actualizar para desbloquear características de la plataforma",
    upgradeToUnlockDescription:
      "Elige un plan de pago a continuación para comenzar a rastrear ofertas y recibir notificaciones de Discord.",
    features: "Características",
    themeAppliedSuccess: "¡Tema aplicado exitosamente!",
    themeApplyError: "Error al aplicar el tema. Por favor intenta de nuevo.",
    discordUrlUpdatedSuccess:
      "¡URL del webhook de Discord actualizada exitosamente!",
    discordUrlUpdateError:
      "Error al actualizar la URL del webhook de Discord. Por favor intenta de nuevo.",
    subscriptionCanceledSuccess:
      "¡Suscripción cancelada exitosamente! Tu cuenta ha sido degradada a gratuita.",
    subscriptionCancelError:
      "Error al cancelar la suscripción. Por favor intenta de nuevo.",
    upgradeError:
      "Error al iniciar la actualización. Por favor intenta de nuevo.",
    invalidPlan: "Plan inválido seleccionado",
    checkoutFailed: "Error al obtener el enlace de pago",
    manageBilling: "Gestionar Facturación",
    billingPortal: "Portal de Facturación",
    billingPortalDescription:
      "Gestiona tu suscripción, métodos de pago e historial de facturación",
    manageBillingButton: "Gestionar Facturación",
    manageBillingError:
      "Error al abrir el portal de facturación. Por favor intenta de nuevo.",
    plans: {
      free: "Gratis",
      basic: "Básico",
      starter: "Inicial",
      pro: "Pro",
      enterprise: "Empresarial",
    },
    themes: {
      grape: "DealHawk",
      grapeDescription:
        "Tema predeterminado de DealHawk con colores uva y platino",
      neutral: "Neutro",
      neutralDescription: "Tema gris limpio y profesional",
      orange: "Naranja",
      orangeDescription: "Tema naranja cálido y energético",
      burgundy: "Borgoña",
      burgundyDescription: "Tema borgoña rico y elegante",
      earthy: "Terroso",
      earthyDescription: "Tema terroso silenciado y natural",
      darkPurple: "Púrpura Oscuro",
      darkPurpleDescription: "Tema púrpura oscuro sofisticado",
      highContrast: "Alto Contraste",
      highContrastDescription: "Tema audaz púrpura y amarillo",
    },
    cancelModal: {
      title: "Cancelar suscripción",
      subtitle: "Ayúdanos a mejorar diciéndonos por qué te vas",
      reasonLabel: "Razón para cancelar",
      reasonPlaceholder: "Por favor, dinos por qué estás cancelando...",
      keepButton: "Mantener suscripción",
      cancelButton: "Cancelar suscripción",
      canceling: "Cancelando...",
    },
  },

  // Products
  products: {
    noStoresAssigned: "No hay tiendas asignadas",
    noStoresAssignedMessage:
      "Necesitas asignar tiendas para ver productos. Configura tus tiendas en Filtros de compra para comenzar a navegar ofertas.",
    assignStores: "Asignar Tiendas",
    failedToLoad: "Error al cargar productos",
    retryLoadMore: "Reintentar cargar más",
    store: "Tienda",
    category: "Categoría",
    searchProducts: "Buscar productos...",
    searchPlaceholder: "Buscar productos...",
    filters: "Filtros",
    newestItemsOnly: "Mostrar Nuevos Descuentos",
    newestItemsDescription:
      "Mostrar artículos recientemente rebajados y ofertas frescas",
    loading: "Cargando...",
    loadingProducts: "Cargando productos...",
    refreshingProducts: "Actualizando productos...",
    loadingUserData: "Cargando datos del usuario...",
    noProductsFound: "No se encontraron productos",
    noProductsFoundMessage:
      "Intenta ajustar tus filtros o términos de búsqueda.",
    activelySearching: "¡Escaneamos ofertas 24/7! 🎯",
    activelySearchingMessage:
      "Nuestro sistema monitorea continuamente el inventario de tus tiendas seleccionadas. Las nuevas ofertas suelen aparecer dentro de 24 horas de la activación. ¡Ten paciencia y vuelve pronto!",
    scanningHeadline: "Buscando ofertas",
    scanningDescription: "Nuestro sistema está monitoreando activamente tus tiendas seleccionadas en busca de inventario en liquidación y con descuento. Los nuevos hallazgos suelen aparecer en 24 horas.",
    scanStep1: "Tiendas configuradas",
    scanStep2: "Escaneando inventario...",
    scanStep3: "Las ofertas aparecerán aquí",
    scanTimeEstimate: "Resultados generalmente en 24 horas",
    emptyStateTipsTitle: "Mientras esperas",
    emptyStateTipStores:
      "Agrega más tiendas en Filtros de compra para aumentar la cobertura.",
    emptyStateTipFilters:
      "Intenta quitar filtros de precio o categoría para resultados más amplios.",
    emptyStateTipSearch: "Limpia tu búsqueda o usa términos más generales.",
    reviewBotFilters: "Revisar filtros de compra",
    resetFilters: "Restablecer filtros",
    discordSuggestion:
      "¡Únete a nuestra comunidad de Discord para consejos y ofertas exclusivas!",
    waitingPeriod: "Nuevas ofertas aparecen dentro de 24 horas",
    supportContact:
      "Contacta soporte si no aparecen productos después de 24 horas",
    addToFavorites: "Agregar a guardados",
    removeFromFavorites: "Quitar de guardados",
    hideProduct: "Ocultar producto",
    hideProductNamed: "Ocultar {{name}}",
    productHidden: "Oculto de {{retailer}}",
    hideProductFailed: "No se pudo ocultar este producto. Intenta de nuevo.",
    undoHideProduct: "Deshacer",
    hiddenProductsTitle: "Productos ocultos",
    hiddenProductsDescription: "Ocultos en todas tus tiendas de {{retailer}}, incluidos productos fuera de la lista actual. El total muestra los productos visibles. Puedes restaurarlos cuando quieras.",
    hiddenProductsChip: "{{count}} ocultos",
    manageHiddenProducts: "Administrar productos ocultos",
    noHiddenProducts: "No hay productos ocultos",
    noHiddenProductsDescription: "Los productos que ocultes de este retailer aparecerán aquí.",
    restoreProduct: "Restaurar",
    restoreAllProducts: "Restaurar todos",
    tabTop: "Top",
    tabAll: "Todo",
    tabCrazyDeals: "Ofertas locas",
    tabPennyDeals: "Ofertas penny",
    dealFeed: "Feed de ofertas",
    tabDealsA11y: "{{label}}: {{count}} ofertas",
    tabDealsA11yNoCount: "{{label}}",
    moreFilters: "Más filtros",
    searchTheseDeals: "Buscar en estas ofertas",
    searchFeedA11y: "Buscar productos en este feed",
    clearSearch: "Borrar búsqueda",
    hiddenTapToRestore: "Toca un producto para mostrarlo de nuevo. Ocultos en todas las tiendas {{retailer}}.",
    hiddenRestored: "Restaurado · de vuelta en tu feed",
    restoreAllCount: "Restaurar todo ({{count}})",
    restoredOne: "1 producto restaurado",
    restoredMany: "{{count}} productos restaurados",
    restoreProductA11y: "Restaurar {{name}}",
    restoredProductA11y: "{{name}}, restaurado",
    restoreProductFailed: "No se pudo restaurar el producto. Intenta de nuevo.",
    viewDetails: "Ver detalles",
    originalPrice: "Precio original",
    currentPrice: "Precio actual",
    discount: "Descuento",
    inStock: "En stock",
    outOfStock: "Agotado",
    availability: "Disponibilidad",
    // ProductItem specific translations
    noImage: "Sin imagen",
    noUpdates: "Sin actualizaciones",
    daysAgo: "hace {{days}}d",
    hoursAgo: "hace {{hours}}h",
    minutesAgo: "hace {{minutes}}m",
    secondsAgo: "hace {{seconds}}s",
    justNow: "Justo ahora",
    inStorePrice: "En tienda:",
    onlinePrice: "En línea:",
    available: "Disponible:",
    aisle: "Pasillo:",
    updating: "Actualizando...",
    favorited: "Favorito",
    favorite: "Favorito",
    tracking: "Alertas",
    track: "Alertar",
    stopping: "Deteniendo...",
    stopTracking: "Detener alertas",
    trackingActiveTitle: "Alertas activas",
    trackingActiveDescription:
      "Este producto tiene alertas configuradas para cambios de precio.",
    targetPriceLabel: "Precio objetivo (debe ser menor a ${{price}})",
    enterTargetPrice: "Ingresa precio objetivo",
    targetPriceTooHigh: "El precio objetivo debe ser menor al precio actual",
    viewOnWalmart: "Ver en Walmart",
    copyUpcTooltip: "Copiar UPC al portapapeles",
    copySkuTooltip: "Copiar SKU al portapapeles",
    clickToViewOnWalmart: "Haz clic para ver en Walmart.com",
    closeImageModal: "Cerrar imagen",
    viewBarcode: "Ver código de barras",
    barcode: "Código de barras",
    closeBarcodeModal: "Cerrar código de barras",
    productBarcode: "Código de barras del producto",
    viewOtherStores: "Ver este producto en otras tiendas",
    validTargetPriceRequired: "Por favor ingresa un precio objetivo válido.",
    targetPriceMustBeLower:
      "El precio objetivo debe ser menor al precio actual (${{price}}).",
    failedToAddTracker:
      "Error al agregar rastreador. Por favor intenta de nuevo.",
    failedToRemoveTracker:
      "Error al eliminar rastreador. Por favor intenta de nuevo.",
    noUpcFound: "No se encontró UPC. No se pueden detener las alertas.",
    addedToFavorites: "Agregado a guardados",
    removedFromFavorites: "Quitado de guardados",
    failedToUpdateFavorites: "Error al actualizar guardados",
    freePreviewBadge: "Acceso en línea gratis",
    freeSavedDealIncluded: "Historial completo de precios en línea",
    freeOnlinePreview: "Todos los feeds en línea incluidos",
    freeUnlockLocalDeals: "Desbloquear ofertas locales",
    freeKeepBrowsing: "Seguir explorando",
    freeDismissWelcome: "Cerrar bienvenida",
    freeHintLocalDeals: "Ofertas locales cerca de ti",
    freeHintLocalDealsNearZip: "Ofertas locales cerca de {{zip}}",
    freeHintMoreDeals: "Guarda y organiza ofertas en línea",
    freeHintMoreDealsCount: "Guarda y organiza ofertas en línea",
    freeHintAlerts: "Configurar alertas de precio",
    freeHintUnlock: "Desbloquear",
    previewModeUnlockMore: "Todas las ofertas en línea están incluidas gratis",
    previewModeUnlockMoreCount: "Todas las ofertas en línea de {{retailer}} están incluidas gratis",
    unlockLocalStoreDeals: "Desbloquear ofertas de tiendas cercanas",
    unlockMoreDeals: "Desbloquear más ofertas",
    unlockLocalDeals: "Desbloquear ofertas locales",
    accessRestricted: "Acceso restringido",
    accessRestrictedMessage: "No tienes acceso a productos de {{retailer}}. Administra tu facturación para obtener acceso.",
    manageBilling: "Administrar facturación",
    noMatchingProducts: "Sin productos coincidentes",
    noMatchingProductsMessage: "{{count}} producto(s) disponible(s), pero ninguno coincide con tus filtros.",
    noMatchingProductsFiltersMessage: "Ningún producto coincide con tus filtros. Prueba a limpiarlos para ver más.",
    clearAllFilters: "Limpiar todos los filtros",
    findingBestDeals: "Buscando las mejores ofertas para ti...",
    scanningForUpdates: "Buscando ofertas cercanas",
    refreshProducts: "Actualizar productos",
    backToTopRefresh: "Volver arriba y actualizar",
    setZipCode: "Configurar código postal",
    setZipCodeDescription: "Ingresa tu código postal para buscar tiendas cercanas.",
    storeAvailability: "Disponibilidad en tienda",
    swipeToSwitchStores: "Desliza para cambiar filtros de ubicación",
    enterCodeToSearch: "Por favor ingresa un código para buscar",
    noResultsForProduct: "No se encontraron resultados para este producto",
    failedToSearchProduct: "Error al buscar producto",
    nearbyTipsTitle: "Consejos y trucos",
    nearbyOnHandTip: "Los productos disponibles pueden estar en el piso de venta o en la trastienda.",
    nearbyLowOnHandNoAisleTip: "Si el conteo disponible es bajo y no aparece pasillo, es menos probable que el producto esté allí.",
    salesFloorLabel: "Piso de venta",
    onHandLabel: "Disponible",
    backroomLabel: "Trastienda",
    storeSortBestDeal: "Mejor oferta",
    storeSortLowestPrice: "Menor precio",
    nearbyNoStock: "Sin existencias en tiendas cercanas",
    nearbyInStockCount: "{{count}} con existencias",
    nearbyStoresChecked: "{{count}} tiendas consultadas",
    showBarcode: "Mostrar código de barras",
    hideBarcode: "Ocultar código de barras",
    storeSortMostOnHand: "Más disponible",
    storeSortClosest: "Más cercano",
    // Trending banner
    trendingToday: "Tendencia hoy",
    newDealsCount: "{{count}} ofertas nuevas · promedio {{percent}}% desc.",
    swipe: "deslizar",
    // ProductItem badges & labels
    badgeNew: "NUEVO",
    badgePriceDown: "PRECIO ↓",
    badgePriceUp: "PRECIO ↑",
    badgeStockUp: "STOCK ↑",
    badgeStockDown: "STOCK ↓",
    soldBy: "Vendido por:",
    noLocation: "Sin ubicación",
    layout: "Diseño",
    pickupShort: "Recogida",
    changedLabel: "Cambió:",
    updatedLabel: "Actualizado:",
    possibleStock: "Stock posible",
    firstSpottedPenny: "Centavo desde",
    lastSeenPenny: "Último precio normal",
    nearbyButton: "Ver stock",
    nearbyCount: "Cercanas ({{count}})",
    moreStores: "+{{count}} más",
    bestLabel: "Mejor",
    productOptions: "Opciones posibles",
    optionsTapHint: "Toca una opción para verla en tiendas cercanas",
    firstUpdated: "Primera actualización",
    lastChanged: "Último cambio",
    lastUpdatedLabel: "Última actualización",
    productCode: "Código del producto",
    optionsButton: "Opciones",
    specialClearance: "Liquidación especial en tienda",
    clearanceInfoTitle: "Info de liquidación",
    clearanceInfoWithSavings: "Este es el precio de liquidación en línea. En tienda puedes encontrar hasta un 70% de descuento en este producto.",
    clearanceInfoWithoutSavings: "Este es el precio en línea. En tienda puedes encontrar hasta un 70% de descuento en este producto.",
    gotIt: "Entendido",
    pickupAvailable: "Recogida disponible",
    openBoxLabel: "Caja abierta",
    saveAmount: "Ahorra {{amount}}",
    cashbackAmount: "{{amount}} de reembolso",
    cashbackAmountMinQty: "{{amount}} de reembolso al comprar {{qty}}",
    ibottaChip: "Ibotta {{amount}} de vuelta",
    ibottaChipGeneric: "Oferta de Ibotta",
    ibottaChipAria: "Posible oferta de Ibotta, ver detalles",
    ibottaModalTitle: "Ofertas de Ibotta",
    ibottaAmountBack: "{{amount}} de vuelta",
    ibottaExpires: "Vence {{date}}",
    ibottaExpiresSoon: "Vence pronto ({{date}})",
    ibottaExpired: "Venció {{date}}",
    ibottaExpirationUnknown: "Vencimiento desconocido",
    ibottaSeen: "Vista en Ibotta {{date}}",
    ibottaPartialMatch: "Coincidencia parcial por nombre: la oferta podría ser para otra variedad.",
    ibottaCaution: "Coincidencia por nombre según una captura guardada. Confirma en la app de Ibotta antes de comprar.",
    ibottaSubtitle: "Posibles coincidencias · vista {{date}}",
    ibottaSubtitleNoDate: "Posibles coincidencias",
    ibottaSimilar: "similar",
    ibottaShowDetails: "Ver detalles de {{name}}",
    ibottaHideDetails: "Ocultar detalles de {{name}}",
    offerBogo: "BOGO",
    offerMixMatch: "Mix & Match",
    regularEach: "Reg. {{amount}} c/u",
    unitInDeal: "{{amount}} c/u al comprar {{count}}",
    percentOffInDeal: "{{percent}}% desc. en la oferta",
    dealPrice: "Oferta",
    percentOffLabel: "{{percent}}% desc.",
    searchStoresButton: "Buscar tiendas",
    enterZipCodeTitle: "Ingresar código postal",
    enterZipCodeDescription: "Ingresa tu código postal para buscar tiendas Home Depot cercanas para este producto.",
    zipCodeLabel: "Código postal",
    locationAvailabilityTitle: "Disponibilidad por ubicación",
    lowestPriceLabel: "Precio más bajo",
    inStockCount: "{{count}} en stock",
    lowStock: "Stock limitado",
    outLabel: "Agotado",
    barcodeNotAvailable: "Código de barras no disponible",
    barcodeNotAvailableDesc: "Este producto no tiene un código de barras escaneable",
    gettingBarcode: "Obteniendo código de barras...",
    gettingBarcodeWait: "Esto puede tardar un momento",
    scanBarcodeHint: "Escanea este código de barras en la caja de autoservicio o muéstralo a un empleado",
    // ProductsHeader
    sortBy: "Ordenar por",
    lowToHigh: "De menor a mayor",
    highToLow: "De mayor a menor",
    oldestFirst: "Más antiguo primero",
    newestFirst: "Más reciente primero",
    filterByStatus: "Filtrar por estado",
    allStoresLabel: "Todas las tiendas",
    storesChipLabel: "Tiendas",
    savedKeywordsTitle: "Palabras clave guardadas",
    tapKeywordsToSearch: "Toca las palabras clave para agregarlas a la búsqueda.",
    noSavedKeywordsYet: "Sin palabras clave guardadas",
    saveSearchReuse: "Guarda tu búsqueda actual para reutilizarla en otros tiendas.",
    selectAllKeywords: "Seleccionar todas",
    clearAllKeywords: "Borrar todas",
    clearSelected: "Borrar selección",
    crazyDeals: "Ofertas locas",
    noCategoriesLabel: "Sin categorías",
    categoriesSheetDescription: "Encuentra lo que buscas",
    sortStorePrice: "Precio en tienda",
    sortStorePriceDesc: "Precio actual rastreado",
    sortMsrp: "Precio de lista",
    sortMsrpDesc: "Precio original publicado",
    sortInventory: "Cantidad en inventario",
    sortInventoryDesc: "Unidades disponibles actualmente",
    sortDiscountAmount: "Monto de descuento",
    sortDiscountAmountDesc: "Precio de lista menos precio actual",
    sortBestDeal: "Mejor oferta",
    sortBestDealDesc: "Más ahorro y % de descuento, de varias categorías",
    sortDiscountPercentage: "Porcentaje de descuento",
    sortDiscountPercentageDesc: "Porcentaje de descuento sobre el precio de lista",
    sortCashbackAmount: "Monto de cash back",
    sortCashbackAmountDesc: "Mayor cash back primero",
    sortOpenBoxDiscount: "Descuento caja abierta",
    sortOpenBoxDiscountDesc: "Porcentaje de descuento sobre el precio de lista para caja abierta",
    sortChanged: "Cambió",
    sortChangedDesc: "Momento del cambio más reciente del producto.",
    sortUpdated: "Actualizado",
    sortUpdatedDesc: "Momento más reciente en que se observó el producto.",
    sortFirstAppeared: "Primera aparición",
    sortFirstAppearedDesc: "Cuando el producto fue actualizado por primera vez",
    // Filters modal
    inStore: "En tienda",
    allSavedStoresDescription: "Ver ofertas en tus tiendas guardadas",
    extraStoresHeading: "Tiendas extra",
    allSavedAndExtraStoresDescription: "Tus tiendas guardadas + {{count}} tiendas extra",
    extraStoreBadge: "Extra",
    extraStoreDistance: "{{miles}} mi",
    extraStoreNear: "a {{miles}} mi de tu tienda de {{city}} (#{{id}})",
    hideExtraStore: "Ocultar",
    hideExtraStoreA11y: "Ocultar {{store}}",
    hiddenExtraStoresToggle: "Tiendas ocultas ({{count}})",
    showHiddenExtraStore: "Mostrar",
    showHiddenExtraStoreA11y: "Mostrar {{store}}",
    extraStoreHiddenToast: "Tienda oculta",
    undoHideExtraStore: "Deshacer",
    resetAll: "Restablecer todo",
    filtersTitle: "Filtros",
    storesTab: "Tiendas",
    categoriesTab: "Categorías",
    priceTab: "Precio",
    otherTab: "Otros",
    onlineDeals: "Ofertas en línea",
    browseOnlineDeals: "Explorar ofertas solo en línea",
    selectLocationFilter: "Seleccionar filtro de ubicación",
    editLocations: "Editar ubicaciones",
    adminStorePickerTitle: "Búsqueda de tienda (Admin)",
    adminStoreLookupOpen: "Buscar cualquier tienda",
    adminStoreSearchPlaceholder: "Buscar por ID, dirección o código postal...",
    adminStoreActive: "Tienda personalizada activa: #{{storeId}}",
    adminStoreNoResults: "Ninguna tienda coincide con tu búsqueda",
    adminStoreMatchCount: "{{count}} tiendas",
    adminStoreEmpty: "Empieza a escribir para buscar en todas las tiendas",
    adminStoreUnknownAddress: "Dirección desconocida",
    adminStoreCatalogCount: "{{count}} tiendas en el catálogo",
    oneStoreConfigured: "Solo tienes una tienda configurada",
    searchCategories: "Buscar categorías...",
    allCountSelected: "Todas las {{count}} seleccionadas",
    noneSelected: "Ninguna seleccionada",
    countOfTotalSelected: "{{count}} de {{total}} seleccionadas",
    noCategoriesMatch: "Ninguna categoría coincide con \"{{search}}\"",
    categoriesSelectedCount: "{{count}} de {{total}} seleccionadas",
    selectAllCategories: "Seleccionar todas",
    clearCategories: "Quitar todas",
    priceFiltersTitle: "Filtros de precio",
    storePriceRange: "Rango de precio en tienda",
    minimumPrice: "Precio mínimo",
    maximumPrice: "Precio máximo",
    noLimit: "Sin límite",
    msrpRange: "Rango de precio de lista",
    minimumMsrp: "Precio de lista mínimo",
    maximumMsrp: "Precio de lista máximo",
    minimumDiscount: "Descuento mínimo",
    discountHint: "Ingresa el porcentaje de descuento (ej., 25 para 25% desc.)",
    clearPriceFilters: "Limpiar filtros de precio",
    additionalFilters: "Filtros adicionales",
    variantsOnly: "Solo variantes",
    variantsOnlyDesc: "Mostrar solo productos con variantes",
    inStockOnly: "Solo en stock",
    inStockOnlyDesc: "Ocultar productos agotados",
    hideCashback: "Ocultar cash back",
    hideCashbackDesc: "Ocultar ofertas con cash back de menos de 20% de descuento",
    hotDeals: "Ofertas calientes",
    hotDealsDesc: "Mostrar solo ofertas locas con grandes descuentos",
    pennyItems: "Artículos de centavo",
    pennyItemsDesc: "Mostrar solo artículos de centavo con rebajas extremas",
    potentialPennyItems: "Artículos de centavo",
    potentialPennyItemsDesc: "Artículos de Dollar General que cambiaron al marcador de $0.00",
    potentialPennyBadge: "Artículo de centavo",
    pennyItemsProListDisclaimer:
      "Las predicciones pueden no reflejar la disponibilidad ni el precio.",
    resetAllFilters: "Restablecer todos los filtros",
    // Status labels
    statusAll: "Todos",
    statusNew: "Nuevos",
    statusPriceDrop: "Baja de precio",
    statusStock: "Stock",
    statusStockUpdate: "Cambio de stock",
    statusCoupon: "Cupón",
    statusAisle: "Pasillo",
    statusWithOptions: "Con opciones",
    statusSaved: "Guardados",
    statusOpenBox: "Caja abierta",
    statusPickupYes: "Recogida ✓",
    statusPickupNo: "Recogida ✗",
    statusOnSale: "En oferta",
    statusSoldByWalmart: "Vendido por Walmart",
    statusSoldByProSeller: "Vendido por Pro Seller",
    statusLowest: "Precio más bajo",
    statusCashback: "Cash back",
    statusIbotta: "Ibotta",
    statusBogo: "BOGO",
    statusMixMatch: "Mix & Match",
    // Sort chip labels
    sortLabelPrice: "Precio",
    sortLabelMsrp: "P. lista",
    sortLabelInventory: "Inventario",
    sortLabelDiscountDollar: "Descuento $",
    sortLabelDiscount: "Descuento",
    sortLabelCashback: "Cash back",
    sortLabelOpenBoxDiscount: "Desc. caja abierta",
    sortLabelChanged: "Cambió",
    sortLabelUpdated: "Actualizado",
    sortLabelNewest: "Más nuevo",
    sortLabelDefault: "Ordenar",
    // Retailer selector
    retailerLabel: "Tienda",
    inStoreTab: "En tienda",
    onlineTab: "En línea",
    lockedLabel: "Bloqueado",
    selectRetailer: "Seleccionar tienda",
    feedsLabel: "Feeds",
    hotDealsLabel: "Mejores Ofertas",
    hawkFindsLabel: "Hawk Finds",
    premiumLabel: "Premium",
    unlockInStoreAccess: "Desbloquear acceso en tienda",
    upgradeRequired: "Actualización requerida",
    freeUpgradeMessage: "Todos los feeds en línea son gratis. Actualiza para obtener datos locales exactos, más guardados, alertas de precio y herramientas avanzadas.",
    paidUpgradeMessage: "Este tienda requiere un plan Pro o superior.",
    accessMoreRetailers: "Accede a más tiendas y vistas en tienda",
    unlockFavoritesAlerts: "Desbloquea favoritos, alertas y datos de productos avanzados",
    viewPlans: "Ver planes",
    hdPlanRequired: "Se requiere plan HD",
    hdPlanRequiredMessage: "Este tienda requiere un plan HD.",
    // Settings page
    profileLabel: "Perfil",
    profileDescription: "Administra tu información de perfil",
    billingDescription: "Administra tu suscripción y facturación",
    notificationsDescription: "Configura las preferencias de notificación",
    supportDescription: "Obtén ayuda y contacta soporte",
    languageDescription: "Cambia tu preferencia de idioma",
    backToSettings: "Volver a ajustes",
    activatingSubscription: "Activando suscripción",
    activatingSubscriptionDesc: "Por favor espera mientras procesamos tu pago y configuramos tu cuenta...",
    subscriptionActivated: "¡Suscripción activada exitosamente! ¡Bienvenido!",
    failedToProcessPayment: "Error al procesar el pago. Por favor contacta soporte.",
    // Profile tab
    subscriptionLabel: "Suscripción",
    manageArrow: "Administrar →",
    cancellingAtPeriodEnd: "Cancelando al final del período",
    activeLabel: "Activo",
    noSubscription: "Sin suscripción",
    plansLabel: "Planes:",
    accessEnds: "Acceso termina:",
    statusLabel: "Estado:",
    renewsMonthly: "Se renueva mensualmente",
    startSubscriptionHint: "Inicia una suscripción para acceder a funciones premium",
    nameLabel: "Nombre",
    emailLabel: "Correo",
    notProvided: "No proporcionado",
    editName: "Editar nombre",
    namePlaceholder: "Tu nombre",
    nameUpdated: "Nombre actualizado.",
    nameUpdateError: "No pudimos actualizar tu nombre.",
    changePhoto: "Cambiar foto",
    removePhoto: "Quitar",
    photoUpdated: "Foto de perfil actualizada.",
    photoRemoved: "Foto de perfil eliminada.",
    photoTooLarge: "Usa un JPEG, PNG o GIF de hasta 2 MB.",
    photoUpdateError: "No pudimos actualizar esa foto.",
    zipCodeSetting: "Código postal",
    deleteAccount: "Eliminar cuenta",
    updateZipCode: "Actualizar código postal",
    updateZipCodeDesc: "Ingresa tu código postal para establecerlo como tu ubicación predeterminada para búsquedas de tiendas cercanas.",
    // Notifications tab
    notificationsTitle: "Notificaciones",
    notificationsDesc: "Elige qué notificaciones quieres recibir.",
    mobileNotificationsHint: "Estos controlan las notificaciones de la app móvil. Si no has configurado preferencias, ambas están habilitadas por defecto.",
    dailyDealsNotifications: "Notificaciones de ofertas diarias",
    dailyDealsNotificationsDesc: "Muestra cuántas ofertas nuevas se han encontrado dos veces al día.",
    crazyWootDeals: "Ofertas Woot increíbles",
    crazyWootDealsDesc: "Recibe notificaciones cuando las ofertas de Woot son excepcionalmente buenas.",
    onlineDealNotifications: "Alertas de ofertas en línea",
    onlineDealNotificationsDesc: "Te avisamos cuando encontramos una gran rebaja en línea cerca de ti.",
    marketingEmails: "Correos promocionales",
    marketingEmailsDesc: "Ofertas de tus tiendas, resúmenes semanales y promociones por correo.",
    manageEmailPreferences: "Administrar preferencias de correo",
    emailOptInCardTitle: "Recibe por correo la lista semanal de liquidación de tu tienda",
    emailOptInCardButton: "Activar",
    emailOptInCardDone: "Listo. Revisa tu correo para la lista de esta semana.",
    discordNotificationsTitle: "Notificaciones de Discord",
    discordNotificationsDesc: "Recibe alertas de ofertas a través de tu cuenta de Discord.",
    discordConnected: "Discord conectado",
    discordConnectedDesc: "Recibirás notificaciones de ofertas en Discord",
    discordNotConnected: "Discord no conectado",
    discordNotConnectedDesc: "Vincula tu cuenta de Discord para recibir notificaciones",
    linkDiscordButton: "Vincular Discord",
    linkingDiscord: "Vinculando...",
    upgradeRequiredNotif: "Actualización requerida",
    discordPaidPlansOnly: "Las notificaciones de Discord están disponibles con planes de pago",
    notificationPrefUpdated: "Preferencias de notificación actualizadas",
    notificationPrefFailed: "Error al actualizar preferencias de notificación",
    // BillingTab
    loadingBilling: "Cargando facturación...",
    freePreview: "Cuenta gratuita",
    freePreviewUpgradeHint: "Todos los feeds en línea están incluidos. Actualiza para datos locales exactos, más guardados y alertas.",
    welcomeBack: "Bienvenido de vuelta:",
    limitedTime: "Tiempo limitado:",
    halfOffFirstMonth: "50% de descuento en el primer mes",
    onlineDealsRow: "Ofertas en línea",
    localStoresRow: "Tiendas locales",
    alertsSavesRow: "Alertas y guardados",
    productSearchRow: "Búsqueda de productos",
    freeOnlineDeals: "Todos, en vivo",
    paidOnlineDeals: "Mismo feed completo",
    freeLocalStores: "Vista previa",
    paidLocalStores: "Exactas, hasta 5",
    freeAlertsSaves: "No incluido",
    paidAlertsSaves: "Más + alertas",
    freeProductSearch: "1/día",
    paidProductSearch: "Ilimitado",
    bestValue: "Mejor valor",
    firstMonth: "primer mes",
    perMo: "/mes",
    unlockPlan: "Desbloquear {{name}}",
    cancelAnytimeStripe: "Cancela en cualquier momento • Pago seguro con Stripe",
    manageYourPlan: "Administra tu plan",
    upgradeToNewPlans: "Actualiza a nuestros nuevos planes simplificados",
    updateSubscription: "Actualiza tu suscripción",
    scheduledCancellation: "Suscripción programada para cancelación",
    subscriptionEndsIn: "Tu suscripción terminará en {{days}} día(s) el {{date}}",
    reactivate: "Reactivar",
    reactivating: "Reactivando...",
    newPlansAvailable: "¡Nuevos planes simplificados disponibles!",
    newPlansDescription: "Hemos simplificado nuestros precios. Elige uno de nuestros nuevos planes a continuación para seguir disfrutando de DealHawk. Tu suscripción actual se cancelará al cambiar.",
    currentPlan: "Plan actual",
    renewsOn: "Se renueva el {{date}}",
    discountApplied: "{{percent}}% de descuento aplicado a la próxima renovación",
    upgradeYourPlan: "Actualiza tu plan",
    changeYourPlan: "Cambia tu plan",
    moveTo: "Cambiar a {{name}}",
    upgradeToPro: "Actualizar a Pro",
    downgradeAtPeriodEnd: "Reducir al final del período",
    downgradeNote: "La reducción de plan tomará efecto al final de tu período de facturación actual",
    choosePlanToStart: "Elige un plan para comenzar",
    paymentMethod: "Método de pago",
    cancelSubscription: "Cancelar suscripción",
    waitSpecialOffer: "¡Espera! Tenemos una oferta especial",
    getHalfOff: "Obtén 50% de descuento en tu próximo mes",
    retentionDescription: "¡No queremos que te vayas! Acepta este descuento único y mantén acceso a todas tus ofertas y alertas.",
    applyingDiscount: "Aplicando...",
    getHalfOffButton: "Obtener 50% de descuento en el próximo mes",
    noThanksCancelAnyway: "No gracias, cancelar de todos modos",
    cancelSubscriptionQuestion: "¿Cancelar suscripción?",
    keepAccessUntilEnd: "Mantendrás acceso hasta que termine tu período de facturación",
    whyAreYouLeaving: "¿Por qué te vas?",
    tooExpensive: "Muy caro",
    foundBetterAlternative: "Encontré una mejor alternativa",
    missingFeatures: "Faltan funciones",
    noLongerNeedIt: "Ya no lo necesito",
    other: "Otro",
    pleaseTellUsMore: "Por favor cuéntanos más",
    enterYourReason: "Ingresa tu razón...",
    canceling: "Cancelando...",
    selectCancelReason: "Por favor selecciona una razón para cancelar",
    provideDetails: "Por favor proporciona detalles sobre tu razón de cancelación",
    failedToCancelSubscription: "Error al cancelar la suscripción",
    failedToReactivate: "Error al reactivar la suscripción",
    failedToChangePlan: "Error al cambiar de plan. Inténtalo de nuevo.",
    failedToStartCheckout: "Error al iniciar el pago. Inténtalo de nuevo.",
    failedToMigratePlan: "Error al iniciar la migración de plan. Inténtalo de nuevo.",
    failedToApplyDiscount: "Error al aplicar el descuento. Inténtalo de nuevo.",
    alreadyHaveActivePlan: "Ya tienes un plan activo. Administra tu facturación.",
    pauseInstead: "Pausar en lugar de cancelar",
    pauseInsteadHint: "¿Necesitas un descanso? Pausa la facturación y retoma donde lo dejaste.",
    pauseBillingDescription: "Mantienes acceso completo hasta el {{accessDate}}. Luego la facturación se pausa por {{duration}} y todo se reanuda automáticamente el {{date}}. Tus tiendas, alertas y configuración quedan guardadas.",
    pauseOneMonth: "1 mes",
    pauseMonths: "{{count}} meses",
    pauseForDuration: "Pausar por {{duration}}",
    pausing: "Pausando...",
    failedToPause: "Error al pausar la suscripción",
    pauseConfirmTitle: "Suscripción en pausa",
    pauseConfirmBody: "Mantienes acceso completo hasta el {{accessDate}}. Después, la facturación se pausa y todo se reanuda automáticamente el {{date}}. Tus tiendas, alertas y configuración están guardadas, y puedes reanudar antes desde Facturación.",
    subscriptionPausedUntil: "Suscripción en pausa hasta el {{date}}",
    subscriptionPausedNote: "Las alertas de ofertas están desactivadas durante la pausa. Tus tiendas y configuración están guardadas.",
    resumeNow: "Reanudar ahora",
    resuming: "Reanudando...",
    subscriptionResumed: "Suscripción reanudada",
    failedToResume: "Error al reanudar la suscripción",
    pauseManagedInAppStore: "La pausa se gestiona en tu tienda de apps: Google Play permite pausar en Play Store › Suscripciones; Apple App Store no permite pausar — puedes desactivar la renovación automática.",
    takingABreak: "Me estoy tomando un descanso",
    dealsWerentAccurate: "Las ofertas no eran precisas",
    cancelStepDownTitle: "Un plan más pequeño puede funcionar mejor",
    cancelStepDownBody: "Cambia a {{plan}} por {{price}}/mes. Mantienes tu plan actual hasta que termine este período de facturación y luego empieza el precio más bajo.",
    cancelStepDownButton: "Cambiar a {{plan}}",
    cancelStepDownScheduled: "Listo. Pasarás a {{plan}} cuando termine este período de facturación.",
    cancelSetupSavedNote: "Tus tiendas y preferencias quedan guardadas. Si continúas, te avisaremos antes de que termine tu acceso para que puedas reactivar sin configurar todo de nuevo.",
    cancelWhichFeature: "¿Qué función necesitabas?",
    cancelWhatWorkedBetter: "¿Qué te funcionó mejor?",
    cancelWhichDealWasOff: "¿Qué tienda u oferta no era correcta?",
    cancelWhichDealWasOffPlaceholder: "p. ej. Walmart #1234, el precio en el estante era diferente",
    cancelInaccurateThanks: "Gracias por avisarnos. Tu reporte llega directo a nuestro equipo para que podamos corregirlo.",
    optionalLabel: "(opcional)",
    subscriptionPauseScheduled: "La pausa empieza el {{accessDate}}. Tienes acceso completo hasta entonces; la facturación se reanuda el {{date}}.",
    // AppearanceTab
    darkMode: "Modo oscuro",
    darkThemeActive: "Tema oscuro activo",
    lightThemeActive: "Tema claro activo",
    colorTheme: "Tema de color",
    chooseAccentColors: "Elige tus colores de acento preferidos",
    applyingTheme: "Aplicando...",
    // StripePaymentModal
    completeYourPurchase: "Completa tu compra",
    payNowToGetAccess: "Paga ahora para obtener acceso",
    settingUpPayment: "Configurando tu pago...",
    paymentSuccessful: "¡Pago exitoso!",
    subscriptionActivatedSuccess: "Tu suscripción ha sido activada exitosamente.",
    redirectingNow: "Redirigiéndote ahora...",
    processingPayment: "Procesando tu pago...",
    pleaseWaitMoment: "Por favor espera, esto puede tardar un momento",
    failedToLoadPaymentForm: "Error al cargar el formulario de pago. Inténtalo de nuevo.",
    // StripePaymentForm
    loadingPaymentForm: "Cargando formulario de pago...",
    completePurchase: "Completar compra",
    processing: "Procesando...",
    paymentDisclaimer: "Se realizará una autorización temporal de $1 en tu tarjeta para verificarla y se liberará inmediatamente. Se te cobrará a partir de hoy.",
    securedByStripe: "Asegurado por Stripe - Cumplimiento PCI DSS Nivel 1",
    // PlanItem
    planLabel: "Plan {{name}}",
    currentBadge: "Actual",
    storeLabel: "{{count}} Tienda",
    storesLabel: "{{count}} Tiendas",
    noRetailersLoading: "No hay tiendas disponibles. Cargando...",
    // LeadsPage
    errorLoadingLeads: "Error al cargar leads",
    searchLeads: "Buscar leads...",
    searchLeadsCount: "Buscar {{count}} leads",
    deals: "ofertas",
    allCategories: "Todas las categorías",
    saved: "Guardados",
    noLeadsFound: "No se encontraron leads",
    noLeadsFoundHint: "Intenta ajustar tu búsqueda o filtros",
    categoryLabel: "Categoría",
    editLead: "Editar lead",
    freeLeadsBanner: "Vista previa: estos leads tienen más de 7 días de antigüedad",
    freeLeadsBannerSub: "Actualiza para obtener los leads más nuevos el día que aparecen, además de guardados y alertas para actuar más rápido.",
    freeLeadsUnlock: "Desbloquear leads frescos",
    freeLeadsPreviewHint: "Modo vista previa: los leads gratuitos muestran oportunidades más antiguas para que evalúes la calidad antes de pagar por el feed en vivo.",
    percentOff: "{{percent}}% desc.",
    storeAvailabilityLabel: "Disponibilidad en tienda",
    setZipCodeTitle: "Configurar código postal",
    setZipCodeDesc: "Ingresa tu código postal para buscar tiendas cercanas para este producto.",
    leadDeleted: "Lead eliminado",
    leadUpdated: "Lead actualizado",
    failedToDeleteLead: "Error al eliminar lead",
    failedToUpdateLead: "Error al actualizar lead",
    savingLabel: "Guardando...",
    // TracksPageNew
    priceAlerts: "Alertas de precio",
    alertsUsed: "{{used}} de {{limit}} alertas usadas",
    readyCount: "{{count}} listas",
    filterAll: "Todas",
    filterReady: "Listas",
    filterWatching: "Vigilando",
    noAlertsYet: "Sin alertas aún",
    noAlertsYetDesc: "Rastrea productos desde los resultados de búsqueda para recibir notificaciones cuando bajen los precios.",
    configureNotificationsIn: "Configura las notificaciones en",
    noAlertsReady: "Ninguna alerta ha alcanzado el objetivo aún",
    noAlertsWatching: "No hay alertas en vigilancia",
    viewAll: "Ver todas",
    failedToLoadAlerts: "Error al cargar alertas",
    tryAgainAction: "Intentar de nuevo",
    storesInStock: "{{count}} tienda(s) en stock",
    outOfStockLabel: "Agotado",
    pickupChecking: "Comprobando recogida…",
    pickupUnverified: "Recogida sin verificar",
    priceChecking: "Comprobando precio…",
    priceUnverified: "Precio sin verificar",
    possiblePenny: "Posible artículo de un centavo",
    possiblePennyDescription: "Esta tienda lo tiene en liquidación pero Home Depot oculta el precio, que es como aparecen los artículos de un centavo. Verifícalo en la caja.",
    inStoreLabel: "en tienda",
    targetLabel: "objetivo",
    refreshLabel: "Actualizar",
    deleteLabel: "Eliminar",
    storeNumber: "Tienda #{{id}}",
    floorLabel: "Piso:",
    backLabel: "Trastienda:",
    copiedLabel: "Copiado",
    zipCodeRequired: "Código postal requerido",
    zipCodeRequiredDesc: "Se necesita un código postal para actualizar los precios del rastreador. Ingresa tu código postal para continuar.",
    setZipCodeToast: "Por favor configura tu código postal para actualizar este rastreador",
  },

  // Product card / gallery / nearby (shared card strings)
  card: {
    upc: "UPC",
    sku: "SKU",
    tcin: "TCIN",
    itemId: "ID del artículo",
    copyCode: "Copiar {{code}}",
    viewBarcode: "Ver código de barras",
    shareLinkCopied: "¡Enlace copiado!",
    shareFailed: "No se pudo compartir la oferta",
    shareLinkFailed: "No se pudo crear el enlace para compartir",
    hdSearchFailed: "No se pudo buscar en las tiendas de Home Depot",
    invalidZip: "Ingresa un código postal válido",
    copiedToClipboard: "{{label}} copiado al portapapeles",
    msrp: "MSRP:",
    lowest: "MÍNIMO",
    openBoxPrice: "Caja abierta {{price}}",
    openBoxPriceOff: "Caja abierta {{price}} ({{percent}}% desc.)",
    openBoxCondition: "Caja abierta · {{condition}}",
    openBoxConditionPriceOff: "Caja abierta · {{condition}} {{price}} ({{percent}}% desc.)",
    openBoxExcellent: "Excelente",
    openBoxGood: "Bueno",
    openBoxFair: "Aceptable",
    openBoxAlso: "También en caja abierta: {{units}}",
    optionCount: "{{count}} opción",
    optionsCount: "{{count}} opciones",
    collapseDetails: "Ocultar detalles",
    expandDetails: "Mostrar detalles",
    share: "Compartir",
    unavailable: "No disponible",
    warehouseNumber: "Bodega #{{id}}",
    storeId: "Tienda {{id}}",
    verdictBuyNow: "🔥 COMPRA YA",
    verdictGoodDeal: "✓ Buena oferta",
    verdictWait: "⏳ Espera",
    verdictOverpriced: "⚠️ Sobreprecio",
    score: "Puntaje:",
    low: "Mín:",
    high: "Máx:",
    daysTracked: "{{count}}d de seguimiento",
    zipPlaceholder: "Ingresa tu código postal (ej. 90210)",
    unknown: "Desconocido",
    clearanceInStore: "Liquidación en tienda",
    hot: "Hot",
    goodDeal: "Buena oferta",
    availCount: "{{count}} disp.",
    viewDetails: "Ver detalles →",
    saveChoiceFailed: "No pudimos guardar tu elección. Intenta de nuevo.",
    browseOnlineDeals: "Ver ofertas en línea",
    resumeSavingDeal: "Continuar guardando la oferta",
    resumePriceHistory: "Continuar con el historial de precios",
    amazonPrice: "Amazon: {{price}}",
    prime: "Prime",
    discord: "Discord",
    bestDeal: "MEJOR OFERTA",
    onClearance: "En liquidación",
    percentOffUpper: "{{percent}}% DESC.",
    openSavedKeywords: "Abrir palabras clave guardadas",
    saveKeyword: "Guardar \"{{term}}\"",
    deleteKeyword: "Eliminar {{keyword}}",
    listView: "Vista de lista",
    galleryView: "Vista de galería",
    listShort: "Lista",
    gridShort: "Cuadrícula",
    moreTab: "Más",
    clearCategorySearch: "Borrar búsqueda de categoría",
    dealStatus: "Estado de la oferta",
  },

  // Product Search
  productSearch: {
    title: "Búsqueda de productos",
    description:
      "Busca información de productos por UPC o SKU en todas tus tiendas",
    searchType: "Tipo de búsqueda",
    upc: "UPC",
    sku: "SKU",
    url: "URL",
    qr: "QR",
    searchButton: "Buscar",
    searchResults: "Resultados de búsqueda",
    noResults: "Sin resultados",
    noResultsMessage:
      "No se encontraron productos con los criterios de búsqueda proporcionados.",
    productFound: "Producto encontrado",
    productInfo: "Información del producto",
    price: "Precio",
    category: "Categoría",
    brand: "Marca",
    productDescription: "Descripción",
    availability: "Disponibilidad",
    storeInfo: "Información de la tienda",
    // URL search
    walmartUrl: "URL del tienda",
    urlPlaceholder:
      "Pega la URL del producto (ej., https://www.walmart.com/ip/nombre-producto/1234567890 o https://www.homedepot.com/p/nombre-producto/123456789)",
    urlHelpText:
      "Compatible: URLs de productos de Walmart y HD. El SKU/ID del producto se extraerá automáticamente de la URL.",
    urlParseError: "Solo se admiten URLs de Walmart y HD",
    invalidUrlFormat: "Formato de URL inválido",
    invalidSkuFormat: "Formato de SKU/ID del producto inválido en la URL",
    failedToParseUrl: "Error al analizar la URL:",
    // QR search
    qrCode: "Código QR",
    qrHelpText:
      "Escanea códigos QR de Walmart para buscar productos automáticamente.",
    qrScanned: "¡Código QR escaneado! Procesando...",
    qrProcessing: "Procesando código QR...",
    qrExtracting: "Extrayendo información del producto",
    scanQrInstruction: "Escanea un código QR de Walmart para buscar",
    scanQrButton: "Escanear código QR",
    failedToProcessQr: "Error al procesar el código QR",
    // Camera/Scanner
    scanBarcodeTitle: "Escanear código de barras con la cámara",
    scanning: "Escaneando...",
    scan: "Escanear",
    scanQrTitle: "Escanear código QR",
    scanBarcodeModalTitle: "Escanear código de barras",
    closeScanner: "Cerrar escáner",
    positionQrCode: "Posiciona el código QR dentro del marco",
    positionBarcode: "Posiciona el código de barras dentro del marco",
    cameraPlaceholder: "La cámara aparecerá aquí cuando comience el escaneo",
    barcodeScannedSuccess: "Código de barras escaneado:",
    // Product details
    skuLabel: "SKU:",
    upcLabel: "UPC:",
    msrpLabel: "Precio de lista:",
    categoryLabel: "Categoría:",
    onlinePriceLabel: "Precio en línea:",
    productBarcode: "Código de barras del producto",
    clickToViewLarger: "Haz clic para ver más grande",
    closeBarcodeView: "Cerrar vista de código de barras",
    // Action buttons
    trackProduct: "Rastrear producto",
    stopTracking: "Detener alertas",
    trackProductMobile: "Alertar",
    stopTrackingMobile: "Detener",
    processing: "Procesando...",
    addFavorite: "Agregar a guardados",
    removeFavorite: "Quitar de guardados",
    addFavoriteMobile: "Guardar",
    removeFavoriteMobile: "Quitar",
    addToDb: "Agregar a BD",
    addToDbMobile: "Agregar BD",
    adding: "Agregando...",
    trackingActive: "✓ Alertas activas",
    // Tooltips
    trackProductTooltip:
      "Configurar alertas para este producto para cambios de precio",
    stopTrackingTooltip: "Detener las alertas de este producto",
    addFavoriteTooltip: "Agregar a guardados",
    removeFavoriteTooltip: "Quitar de guardados",
    addToDbTooltip: "Agregar este producto a la base de datos",
    // Store availability
    storeAvailabilityTitle: "Disponibilidad y precios en tiendas",
    storePrice: "Precio en tienda",
    stock: "Stock",
    location: "Ubicación",
    inStock: "En stock",
    outOfStock: "Sin stock",
    notSpecified: "No especificado",
    percentOff: "% DESC",
    // Results and errors
    productNotFound: "Producto no encontrado",
    allStoresFailed: "No se pudo buscar este producto en todas las tiendas.",
    someStoresFailed:
      "No se pudieron buscar algunas tiendas. Esto puede deberse a problemas de red o a que el producto no esté disponible en esas ubicaciones.",
    outOfStockHidden: "tienda(s) con productos agotados están ocultas.",
    // User messages
    noStoresConfigured:
      "No tienes tiendas configuradas. Por favor, configura tus tiendas en la",
    setupPage: "página de configuración",
    toUseProductSearch: "para usar la búsqueda de productos.",
    // Alerts and notifications
    pleaseLoginFavorites: "Por favor, inicia sesión para agregar a guardados.",
    noProductUpcAvailable:
      "No hay UPC de producto disponible para agregar a guardados.",
    productAddedToFavorites: "¡Producto agregado a guardados!",
    productRemovedFromFavorites: "Producto quitado de guardados.",
    failedToUpdateFavorites: "Error al actualizar guardados.",
    trackingFunctionalityDisabled:
      "La funcionalidad de alertas se está actualizando para soporte multi-tienda. ¡Por favor vuelve pronto!",
    adminFunctionalityDisabled:
      "La funcionalidad de administrador para agregar a la base de datos se está actualizando para soporte multi-tienda. ¡Por favor vuelve pronto!",
  },

  // Top feed (TopProductsView)
  topFeed: {
    todaysTopDeals: "Mejores ofertas de hoy",
    bestDealsNow: "Mejores ofertas ahora",
    freshSubtitle: "{{count}} nuevas · {{pct}}% dto. promedio",
    bestMarkdownsNow: "Las mejores rebajas disponibles ahora",
    justDropped: "Recién llegadas",
    moreTopPicks: "Más destacadas",
    hot: "HOT",
    nearby: "Cerca",
    percentOffShort: "{{pct}}% dto.",
    storeFallback: "Tienda {{id}}",
    freshOnlineDeals: "Ofertas en línea recientes",
    addedInLastHours: "{{count}} añadidas en las últimas {{hours}}h",
    strongMarkdowns: "Buenas rebajas en línea disponibles ahora",
    seeAllNew: "Ver todas las nuevas",
    topCategory: "Top {{category}}",
    railSubtitle: "{{count}} ofertas · {{pct}}% dto. promedio",
    seeAll: "Ver todo",
    browseAllDeals: "Explorar las {{count}} ofertas",
    online: "En línea",
    onlineSoldBy: "En línea · Vendido por {{seller}}",
    left: "Quedan {{count}}",
    lowStock: "Stock limitado",
    checkStock: "Consultar stock",
    inStock: "En stock",
    aisle: "Pasillo {{aisle}}",
    updated: "Actualizado {{time}}",
    youSave: "Ahorras",
    discount: "Descuento",
    dayLow: "Mínimo en {{days}} días",
    yes: "Sí",
    lowestSeen: "Mínimo visto",
    listed: "Publicado",
    today: "Hoy",
    topDealToday: "Oferta del día",
    upgradeToSaveDeals: "Mejora tu plan para guardar ofertas",
    realWins: "Hallazgos reales de miembros de DealHawk",
    viewDeal: "Ver oferta",
    loadingCommunity: "Cargando éxitos de la comunidad",
    communitySuccess: "Éxitos de la comunidad",
    communitySubtitle: "Hallazgos reales de miembros de DealHawk",
    communityDealFind: "Hallazgo de la comunidad",
    communityFree: "Los hallazgos de la comunidad son gratis",
    communityFreeSub: "Mira lo que los miembros están encontrando en tiendas ahora mismo.",
    freeToBrowse: "Gratis para explorar",
    upgradeToShare: "Mejora tu plan para compartir tus hallazgos",
    justNow: "ahora mismo",
    minutesAgo: "hace {{count}}m",
    hoursAgo: "hace {{count}}h",
    daysAgo: "hace {{count}}d",
    badgeLowest: "MÍNIMO",
    badgeNew: "NUEVO",
    percentOff: "{{pct}}% DTO.",
  },

  // Leads (TopLeadsView, LeadsPage, LeadSaveButton)
  leads: {
    badgeJustNow: "ahora mismo",
    badgeMinutes: "{{count}}m",
    badgeHours: "{{count}}h",
    badgeDays: "{{count}}d",
    todaysTopLeads: "Leads top de hoy",
    bestLeadsNow: "Los mejores leads ahora",
    freshSubtitle: "{{count}} nuevos · {{pct}}% dto. promedio",
    bestMarkdownsNow: "Las mejores rebajas disponibles ahora",
    seeAllCount: "Ver los {{count}}",
    moreOnTheWay: "Más leads top en camino",
    browseAllHint: "Explora todos los leads para ver cada oferta disponible.",
    topCategory: "Top {{category}}",
    seeAll: "Ver todo",
    moreTopPicks: "Más selecciones top",
    justDropped: "Recién llegados",
    newestLeadsFirst: "Leads más nuevos primero",
    browseAllLeadsCount: "Explorar todos los {{count}} leads",
    browseAllLeads: "Explorar todos los leads",
    previousProducts: "Productos anteriores de {{title}}",
    nextProducts: "Siguientes productos de {{title}}",
    railProducts: "Productos de {{title}}",
    percentOff: "{{pct}}% DTO.",
    visit: "Visitar",
    topLeads: "Leads top",
    topLeadsShort: "Top",
    allLeads: "Todos los leads",
    allLeadsShort: "Todo",
    leadsView: "Vista de leads",
    aboutTitle: "¿Qué son los leads?",
    aboutBody: "Hallazgos de liquidación seleccionados en tiendas de todo el país. Toca {{action}} para ver el precio y las existencias en tiendas cercanas.",
    aboutDismiss: "Cerrar la explicación de leads",
    admin: "Admin",
    manageCategories: "Administrar categorías",
    manageCategoriesHint: "Renombra las etiquetas con el lápiz o usa las flechas para ordenar las categorías.",
    closeCategoryManager: "Cerrar administrador de categorías",
    noCustomCategories: "Aún no hay categorías personalizadas",
    noCustomCategoriesHint: "Crea una importando productos desde un canal de Discord.",
    editLabelNamed: "Editar etiqueta de {{name}}",
    editLabel: "Editar etiqueta",
    moveUpNamed: "Subir {{name}}",
    moveUp: "Subir",
    moveDownNamed: "Bajar {{name}}",
    moveDown: "Bajar",
    deleteCategoryNamed: "Eliminar la categoría {{name}}",
    deleteCategory: "Eliminar categoría",
    newCategory: "Nueva categoría",
    saveOrder: "Guardar orden",
    confirmDeleteLead: "¿Eliminar \"{{title}}\"?",
    optionsWalmartOnly: "La búsqueda de opciones solo está disponible para leads de Walmart",
    foundOptions: "Se encontraron {{count}} opciones",
    noOptionsFound: "No se encontraron opciones",
    failedFindOptions: "No se pudieron buscar las opciones",
    confirmDeleteCategory: "¿Eliminar la categoría “{{name}}”?\n\nSus leads seguirán disponibles en Todos los leads.",
    categoryDeleted: "Categoría “{{name}}” eliminada",
    failedDeleteCategory: "No se pudo eliminar la categoría",
    editCategoryLabelPrompt: "Editar etiqueta de la categoría",
    categoryLabelChanged: "Etiqueta de la categoría cambiada a “{{name}}”",
    failedUpdateCategoryLabel: "No se pudo actualizar la etiqueta de la categoría",
    categoryOrderSaved: "Orden de categorías guardado",
    failedSaveCategoryOrder: "No se pudo guardar el orden de categorías",
    allCategories: "Todas las categorías",
    categoriesCount: "{{count}} categorías",
    copied: "{{label}} copiado",
    link: "Enlace",
    failedSearchProduct: "No se pudo buscar el producto",
    failedToLoad: "No se pudo cargar",
    refreshLeads: "Actualizar leads",
    createCategory: "Crear categoría",
    createLeadCategory: "Crear categoría de leads",
    chooseCategory: "Elegir categoría",
    savedLeads: "Leads guardados",
    sortLeads: "Ordenar leads",
    savings: "Ahorro",
    newest: "Más nuevos",
    hideSearch: "Ocultar búsqueda",
    showSearch: "Mostrar búsqueda",
    searchLeads: "Buscar leads",
    clearSearch: "Borrar búsqueda",
    leadsCount: "{{count}} leads",
    chooseCategories: "Elegir categorías",
    clear: "Limpiar",
    clearCategories: "Limpiar categorías",
    manage: "Administrar",
    findCategory: "Buscar una categoría",
    applyCategories: "Aplicar categorías",
    showLeadsCount: "Mostrar {{count}} leads",
    newestFirst: "Más nuevos primero",
    biggestSavings: "Mayor ahorro",
    moreActions: "Más acciones",
    visitSite: "Visitar {{site}}",
    opensProductPage: "Abre la página del producto",
    copySku: "Copiar SKU",
    copyLabel: "Copiar {{label}}",
    share: "Compartir",
    unavailable: "No disponible",
    checkNearby: "Ver stock",
    groupLastHour: "Última hora",
    groupToday: "Hoy",
    groupYesterday: "Ayer",
    groupThisWeek: "Esta semana",
    groupOlder: "Anteriores",
    tierHuge: "80% o más de descuento",
    tierBig: "50–79% de descuento",
    tierSmall: "Hasta 49% de descuento",
    tierNone: "Otros hallazgos",
    optionsCount: "{{count}} opciones",
    adminEditLead: "Editar lead",
    adminFindOptions: "Buscar opciones",
    adminDeleteLead: "Eliminar lead",
    layoutLabel: "Diseño",
    layoutGrid: "Vista de cuadrícula",
    layoutList: "Vista de lista",
    more: "Más",
    fieldTitle: "Título",
    fieldUpc: "UPC",
    fieldSku: "SKU",
    fieldCategory: "Categoría",
    fieldLowestPrice: "Precio más bajo",
    fieldMsrp: "MSRP",
    fieldOnlinePrice: "Precio en línea",
    fieldImageUrl: "URL de imagen",
    relJustNow: "Justo ahora",
    relMinutesAgo: "hace {{count}}m",
    relHoursAgo: "hace {{count}}h",
    relDaysAgo: "hace {{count}}d",
    removeFromSaved: "Quitar de guardados",
    addToSaved: "Agregar a guardados",
    removing: "Quitando...",
    adding: "Agregando...",
    saved: "Guardado",
    save: "Guardar",
  },

  // Admin
  admin: {
    title: "Panel de administración",
    description: "Administra tu plataforma DealHawk",
    users: "Usuarios",
    categories: "Categorías",
    manageUsers: "Administrar usuarios",
    manageCategories: "Administrar categorías",
    addUser: "Agregar usuario",
    editUser: "Editar usuario",
    deleteUser: "Eliminar usuario",
    addCategory: "Agregar categoría",
    editCategory: "Editar categoría",
    deleteCategory: "Eliminar categoría",
    userCreated: "Usuario creado exitosamente",
    userUpdated: "Usuario actualizado exitosamente",
    userDeleted: "Usuario eliminado exitosamente",
    categoryCreated: "Categoría creada exitosamente",
    categoryUpdated: "Categoría actualizada exitosamente",
    categoryDeleted: "Categoría eliminada exitosamente",
  },

  // Product search page
  searchPage: {
    title: "Encuéntralo en tienda",
    subtitle: "Precio y stock de cualquier artículo en tus tiendas {{retailer}}.",
    lockedOnFree: "La búsqueda de productos está bloqueada en el plan gratis. Mejora a Basic o Pro.",
    noResultsForTracking: "No hay resultados de búsqueda para crear una alerta",
    trackerAdded: "¡Alerta creada!",
    trackerAddFailed: "No se pudo crear la alerta",
    enterCode: "Ingresa un UPC, SKU o URL de producto",
    enterZip: "Ingresa tu código postal",
    enterZipToSearch: "Ingresa tu código postal para buscar",
    unableToDetectCode: "No se pudo detectar el tipo de código. Revisa lo que ingresaste.",
    searchFailed: "No se pudo buscar el producto",
    missingCodeOrZip: "Falta el código de búsqueda o el código postal",
    cameraAccessDenied: "Acceso a la cámara denegado",
    cameraError: "Error de cámara: {{message}}",
    photoDecodeFailed: "No se pudo leer el código de barras de la foto",
    noResultsForDiscord: "No hay resultados válidos para enviar a Discord",
    noResultsForLeads: "No hay resultados válidos para agregar a leads",
    shareLinkCopied: "¡Enlace copiado!",
    shareLinkFailed: "No se pudo crear el enlace para compartir",
    historyLoadFailed: "No se pudo cargar el historial",
    providersLoadFailed: "No se pudieron cargar los proveedores de búsqueda",
    placeholderHomeDepot: "Ingresa el ItemId o URL de HD",
    placeholderDollarGeneral: "Ingresa el UPC o URL de Dollar General",
    placeholderTarget: "Ingresa el TCIN (SKU de Target)",
    placeholderBestBuy: "Ingresa el SKU de Best Buy",
    placeholderCostco: "Ingresa el número de artículo de Costco",
    placeholderTractorSupply: "Ingresa el número de artículo, SKU, UPC o URL de Tractor Supply",
    placeholderSamsClub: "Ingresa el UPC o el n.º de artículo de Sam's Club",
    placeholderAmazon: "Ingresa el ASIN de Amazon",
    placeholderWalmart: "Ingresa el UPC, SKU o URL de Walmart",
    clearSearch: "Borrar búsqueda",
    detected: "Detectado: {{type}}",
    scanBarcode: "Escanear código de barras",
    uploadBarcodePhoto: "Subir foto del código de barras",
    photo: "Foto",
    setZipCode: "Configurar código postal",
    setZip: "Código postal",
    zipPlaceholder: "Ingresa tu código postal",
    scope: "Alcance",
    myStores: "Mis tiendas",
    nationwide: "Todo el país",
    adminOnly: "Solo admin",
    dataSource: "Fuente de datos",
    userOverride: "Ajuste del usuario ({{provider}})",
    defaultProvider: "Predeterminado (según config)",
    providerDisabled: "desactivado",
    bypassCache: "Omitir caché",
    recent: "Recientes",
    noSearchesYet: "Aún no hay búsquedas",
    noSearchesYetHint: "Tus búsquedas de productos aparecerán aquí",
    stockOf: "{{inStock}} de {{total}} en stock",
    outOfStock: "Agotado",
    noResults: "Sin resultados",
    unknownProduct: "Producto desconocido",
    viewResultsFor: "Ver resultados de {{name}}",
    searchAgainFor: "Buscar de nuevo {{name}}",
    noMoreResults: "No hay más resultados",
    liveScanner: "Escáner en vivo",
    scannerHintQr: "Mantén el código dentro del marco hasta que se lea.",
    scannerHintBarcode: "Llena el marco con el código de barras para una lectura más rápida.",
    cameraReady: "Cámara lista",
    initializingCamera: "Iniciando cámara",
    squareFocus: "Enfoque cuadrado",
    horizontalBarcodeFocus: "Enfoque horizontal de código de barras",
    cameraErrorTitle: "Error de cámara",
    guidance: "Guía",
    guidanceQr: "Centra el código QR en la guía cuadrada y mantén la cámara quieta un momento.",
    guidanceBarcode: "Alinea el código de barras con la línea de escaneo sin cortar los bordes.",
    scanningLive: "Escaneando en vivo",
    preparingScanner: "Preparando escáner",
    hdNationwideSearching: "Buscando en todas las tiendas Home Depot — puede tardar unos 2 minutos.",
    clientSearchTime: "Tiempo de búsqueda del cliente:",
    durationMs: "{{ms}} ms",
    durationS: "{{s}} s",
    serviceMaintenance: "Mantenimiento del servicio",
    searchError: "Error de búsqueda",
    unlockLocalSearch: "Desbloquear búsqueda local",
    unableToFindAtStores: "No se encontró en ninguna tienda",
    notFound: "No encontrado",
    itemLabel: "Artículo",
    bestStore: "Mejor tienda",
    online: "En línea",
    share: "Compartir",
    lead: "Lead",
    admin: "Admin",
    storeCount: "{{count}} tienda",
    storeCountPlural: "{{count}} tiendas",
    outOfStockCount: "{{count}} sin stock",
    clearance: "Liquidación",
    addressCopied: "Dirección copiada",
    copyFailed: "No se pudo copiar",
    clickToCopy: "Haz clic para copiar",
  },

  // Alerts
  alerts: {
    justNow: "ahora",
    minutesAgo: "hace {{m}} min",
    hoursAgo: "hace {{h}} h",
    daysAgo: "hace {{d}} d",
    stopTrackingConfirm: "¿Seguro que quieres dejar de seguir este artículo?",
    removeFailed: "No se pudo eliminar",
    alreadyTracked: "Ya tienes una alerta para este producto.",
    trackerAdded: "¡Alerta creada!",
    trackerAddFailed: "No se pudo crear la alerta",
    adding: "Agregando...",
    tracking: "Con alerta",
    alert: "Alerta",
    upgradeTitle: "Convierte las ofertas prometedoras en alertas al instante",
    upgradeDescription: "Sigue {{productName}} y recibe un aviso cuando cambie el precio o el stock, sin tener que revisarlo a mano.",
    upgradeHighlightNotify: "Recibe alertas cuando cambie el precio o el stock",
    upgradeHighlightMonitor: "Vigila las ofertas que ya validaste en la vista previa",
    upgradeHighlightLocal: "Desbloquea la visibilidad de tiendas locales y más resultados en vivo",
    unlockAlerts: "Desbloquear alertas",
    limitTitle: "Límite de alertas alcanzado",
    limitSubtitle: "Llegaste al máximo",
    usageLabel: "Uso de alertas",
    noSlotsAvailable: "0 espacios disponibles",
    limitUsingAll: "Estás usando tus",
    limitPriceAlerts: "{{limit}} alertas de precio",
    limitRemoveFirst: "Para agregar una nueva alerta, primero elimina una existente.",
    tipLabel: "💡 Consejo:",
    tipText: "Revisa tus alertas y elimina las de productos que ya compraste o que ya no te interesan.",
    manageMyAlerts: "Administrar mis alertas",
  },

  // Help
  help: {
    title: "Ayuda y soporte",
    description: "Obtén la ayuda que necesitas de nuestro equipo de soporte",
    contactSupport: "Contactar soporte",
    contactSupportDescription:
      "¿Necesitas ayuda? Únete a nuestro servidor de Discord para soporte instantáneo de nuestra comunidad y equipo.",
    joinDiscord: "Unirse a Discord",
    joinDiscordDescription:
      "Obtén soporte en tiempo real y conéctate con otros usuarios de DealHawk",
    howToGetSupport: "Cómo obtener soporte",
    joinDiscordServer: "Únete a nuestro servidor de Discord",
    joinDiscordServerDescription:
      "Haz clic en el botón de abajo para unirte a nuestra comunidad de Discord donde puedes obtener ayuda en tiempo real.",
    createSupportTicket: "Crear un ticket de soporte",
    createSupportTicketDescription:
      "En el servidor de Discord, usa los canales de soporte para crear un ticket para asistencia personalizada.",
    getHelpFromTeam: "Obtener ayuda de nuestro equipo",
    getHelpFromTeamDescription:
      "Nuestro equipo de soporte responderá a tu ticket y te ayudará a resolver tu problema rápidamente.",
    joinDiscordServerButton: "Unirse al servidor de Discord",
    needImmediateAssistance:
      "¿Necesitas asistencia inmediata? Nuestra comunidad de Discord está activa las 24 horas del día, los 7 días de la semana, con miembros útiles y personal de soporte.",
  },

  // Community Success
  community: {
    reasonSpam: "Spam o estafa",
    reasonHarassment: "Acoso u odio",
    reasonUnsafe: "Inseguro o inapropiado",
    reasonOther: "Otra cosa",
    justNow: "justo ahora",
    minutesAgo: "hace {{count}} min",
    hoursAgo: "hace {{count}} h",
    daysAgo: "hace {{count}} d",
    confirmSaveFailed: "No pudimos guardar esa confirmación. Inténtalo de nuevo.",
    gateTitle: "Una cosa rápida",
    gateBody: "Logros de la comunidad es donde los miembros comparten sus hallazgos. Confirma que tienes 18+ para unirte al feed — solo lo preguntamos una vez.",
    saving: "Guardando…",
    confirmAdult: "Tengo 18+",
    postLive: "Tu logro ya está publicado. ¡Buen hallazgo!",
    publishFailed: "No pudimos publicar tu logro.",
    composerA11y: "Comparte un logro con la comunidad",
    composerTitle: "Comparte un logro",
    composerSubtitle: "Agrega fotos y cuéntanos qué conseguiste.",
    closeComposer: "Cerrar editor",
    photosLabel: "Fotos del logro",
    changePhotos: "Cambiar fotos · {{count}}/5",
    addPhotos: "Agrega de 1 a 5 fotos de tu logro",
    photoFormats: "JPEG, PNG o GIF · 5 MB cada una",
    firstPhotoAlt: "Primera foto seleccionada del logro",
    selectedPhotoAlt: "Foto seleccionada {{index}}",
    removePhoto: "Quitar foto {{index}}",
    scoreLabel: "¿Qué conseguiste?",
    scorePlaceholder: "¿Qué encontraste, dónde y por cuánto?",
    guidelinesPrefix: "Acepto las",
    guidelinesLink: "Normas de la comunidad y los Términos",
    guidelinesSuffix: ". Todas las publicaciones se revisan.",
    reviewingPost: "Revisando tu publicación…",
    submit: "Compartir logro",
    reportContent: "Reportar este contenido",
    reportMemberInstead: "Mejor reportar al miembro",
    photoAlt: "Logro de compra de un miembro de DealHawk, foto {{index}} de {{total}}",
    previousPhoto: "Foto anterior",
    nextPhoto: "Foto siguiente",
    showPhoto: "Mostrar foto {{index}}",
    photoDialog: "Foto del logro",
    closePhoto: "Cerrar foto",
    reportThanks: "Gracias, nuestro equipo lo revisará.",
    reportFailed: "No pudimos enviar ese reporte.",
    reportMemberThanks: "Gracias, nuestro equipo revisará el reporte de este miembro.",
    memberContentHidden: "El contenido de ese miembro ya está oculto para ti.",
    memberPostsHidden: "Las publicaciones de ese miembro ya están ocultas para ti.",
    blockFailed: "No pudimos bloquear a ese miembro.",
    deleteCommentConfirm: "¿Eliminar este comentario? No se puede deshacer.",
    commentRemoved: "Comentario eliminado.",
    deleteCommentFailed: "No pudimos eliminar ese comentario.",
    postCommentFailed: "No pudimos publicar ese comentario.",
    likeFailed: "No pudimos actualizar ese me gusta.",
    deletePostConfirm: "¿Eliminar esta publicación? No se puede deshacer.",
    postRemoved: "Publicación eliminada.",
    deletePostFailed: "No pudimos eliminar esa publicación.",
    comments: "Comentarios",
    closeComments: "Cerrar comentarios",
    commentsSubtitle: "Sé amable y aporta algo útil.",
    commentOptions: "Opciones del comentario",
    deleteComment: "Eliminar comentario",
    reportComment: "Reportar comentario",
    reportMember: "Reportar miembro",
    blockMember: "Bloquear miembro",
    startConversation: "Inicia la conversación",
    noCommentsYet: "Aún no hay comentarios",
    startConversationHint: "Haz una pregunta útil o celebra su logro.",
    upgradeToCelebrate: "Mejora tu plan para ser el primero en celebrar este logro.",
    commentGuidelinesPrefix: "Acepto las",
    commentGuidelinesLink: "Normas de la comunidad",
    commentGuidelinesSuffix: ".",
    commentPlaceholder: "Escribe un comentario amable…",
    postComment: "Publicar comentario",
    upgradeToComment: "Mejora tu plan para comentar",
    memberBadge: "Miembro de DealHawk",
    newBadge: "Nuevo",
    sourceDiscord: "Discord",
    postOptions: "Opciones de la publicación",
    deletePost: "Eliminar publicación",
    reportPost: "Reportar publicación",
    unlikePost: "Quitar me gusta",
    likePost: "Me gusta",
    loadFailed: "No pudimos cargar Logros de la comunidad. Inténtalo de nuevo.",
    title: "Logros",
    newCount: "{{count}} nuevos",
    subtitle: "Lo que consiguen los miembros",
    shareWin: "Compartir",
    upgradeToPost: "Mejora tu plan para publicar",
    emptyTitle: "Sé la primera historia de éxito",
    emptyTitleLocked: "¿Ves un logro? Mejora tu plan para compartir el tuyo",
    emptyText: "¿Conseguiste algo con DealHawk? Comparte la foto que lo demuestra.",
    emptyTextLocked: "Los miembros gratuitos pueden ver Logros de la comunidad. Mejora tu plan para publicar tus hallazgos.",
    emptyButton: "Compartir logro",
    upgradeToShare: "Mejora tu plan para compartir",
    loadingMore: "Cargando más…",
    footerNote: "Logros de la comunidad es para compras que hiciste con DealHawk, no para promociones, reventa ni información personal.",
    navLabel: "Logros de la comunidad",
    navNewWins: "{{count}} logros nuevos de la comunidad",
  },

  // Setup
  setup: {
    title: "Configuración",
    description: "Completa tu configuración de DealHawk",
    step: "Paso",
    of: "de",
    chooseLanguage: "Elegir idioma",
    chooseLanguageSubtitle: "Selecciona tu idioma preferido para continuar.",
    selectLanguage: "Seleccionar idioma",
    languageDescription: "Elige tu idioma preferido para la aplicación",
    chooseWalmartCategories: "Elegir Categorías de Walmart",
    chooseHomeDepotCategories: "Elegir Categorías de HD",
    searchCategories: "Buscar categorías...",
    failedToLoadCategories: "Error al cargar categorías",
    noCategoriesAvailable:
      "No hay categorías de {{retailerName}} disponibles. Por favor, inténtalo de nuevo más tarde.",
    noCategoriesMatchSearch:
      "No hay categorías que coincidan con tus criterios de búsqueda. Intenta con un término de búsqueda diferente.",
    categoriesSelectedCount: "{{count}} de {{total}} categorías seleccionadas",
    freeTrialTitle: "Inicia tu prueba gratuita hoy",
    freeTrialDescription:
      "Prueba DealHawk sin riesgo por 3 días. No se requiere tarjeta de crédito para comenzar.",
    fullAccessFeatures: "Acceso completo a todas las funciones",
    cancelAnytime: "Cancela en cualquier momento",
    choosePlan: "Elegir plan",
    selectStores: "Seleccionar tiendas",
    selectCategories: "Seleccionar categorías",
    complete: "Completar",
    getStarted: "Comenzar",
    startFreeTrial: "Iniciar prueba gratuita",
    selectPlanDescription:
      "Elige el plan que mejor se adapte a tus necesidades",
    selectStoresDescription: "Selecciona las tiendas que quieres monitorear",
    selectCategoriesDescription:
      "Elige las categorías de productos que te interesan",
    completeSetup: "Completar configuración",
    noCreditCard: "No se requiere tarjeta de crédito",
    choosePlanSubtitle: "Comienza con un plan que funcione para ti.",
    chooseCategoriesSubtitle:
      "Selecciona las categorías que quieres monitorear.",
    chooseStoresSubtitle: "Selecciona las tiendas que quieres rastrear.",
    basic: "Básico",
    starter: "Inicial",
    pro: "Pro",
    enterprise: "Empresarial",
    popular: "Popular",
    discordAccess: "Acceso a Discord",
    standardMonitoring: "Monitoreo estándar",
    advancedMonitoring: "Monitoreo avanzado",
    premiumMonitoring: "Monitoreo premium",
    prioritySupport: "Soporte prioritario",
    dedicatedSupport: "Soporte dedicado 24/7",
    allPlansIncludeTrial:
      "Todos los planes incluyen una prueba gratuita de 3 días • ¿Necesitas más capacidades para tu negocio?",
    contactEnterprise:
      "Contáctanos para soluciones empresariales personalizadas",
    chooseWhatToSee: "Elige lo que quieres ver",
    addCategories: "+ Agregar categorías",
    noCategoriesSelected: "No hay categorías seleccionadas",
    noCategoriesMessage:
      'No hay categorías seleccionadas. Haz clic en "Agregar categorías" para comenzar.',
    chooseYourStores: "Elige tus tiendas",
    noStoresSelected: "No hay tiendas seleccionadas",
    noStoresMessage:
      'No hay tiendas seleccionadas. Haz clic en "Seleccionar tiendas" para comenzar.',
    skipForNow: "Omitir por ahora",
    errorPlan: "Error con el plan seleccionado. Inténtalo de nuevo.",
    errorSetup: "Error al finalizar la configuración. Inténtalo de nuevo.",
    storeText: "Tienda",
    stores: "Tiendas",
    allCategories: "Todas las categorías",
    selectedStores: "Tiendas seleccionadas",
    addStores: "+ Agregar tiendas",
    select: "Seleccionar",
    address: "Dirección",
    zipCode: "Código postal",
    yourZipCode: "Tu código postal",
    zipCodePlaceholder: "Ingresa código postal de 5 dígitos",
    invalidZipCode: "Por favor ingresa un código postal válido de 5 dígitos",
    validZipCode: "Código postal válido",
    invalidZipCodeError:
      "Por favor ingresa un código postal válido de 5 dígitos antes de continuar.",
    storeId: "ID de tienda",
    starting: "Iniciando...",
    continue: "Continuar",
    needHelp: "¿Necesitas ayuda?",
    contactTeam: "Contacta a nuestro equipo",
    allPlansIncludeAccess:
      "Todos los planes incluyen acceso completo a nuestras herramientas de monitoreo",
    buildYourPlan: "Crea tu plan",
    trialMode: "🎉 Modo de prueba:",
    trialModeDescription:
      "Solo puedes agregar otros planes elegibles para prueba. Elimina planes de prueba para agregar planes de pago.",
    paidMode: "💳 Modo de pago:",
    paidModeDescription:
      "Solo puedes agregar otros planes de pago. Elimina planes de pago para agregar planes de prueba.",
    chooseYourPlan: "Elige tu plan",
    noPlanSelected: "Ningún plan seleccionado",
    storesPlural: "Tiendas",
    perMonthShort: "/mes",
    threeDayTrial: "Prueba de 3 días",
    noTrialPayNow: "Sin prueba • Paga ahora",
    trialOnlyWithTrials: "Prueba solo con otras pruebas",
    noTrialsWithPaid: "Sin pruebas con planes de pago",
    discord: "Discord",
    alwaysIncluded: "Siempre incluido",
    monthlyTotal: "Total Mensual",
  },

  // Extension
  extension: {
    title: "Extensión de Chrome",
    description:
      "Busca ofertas directamente desde cualquier sitio web con nuestra extensión de Chrome.",
    downloadExtension: "Descargar extensión",
    downloadDescription:
      "Instala la extensión DealHawk de Chrome para buscar productos y comparar precios mientras navegas por cualquier sitio web de compras.",
    visitChromeStore: "Visitar Chrome Web Store",
    comingSoon: "Extensión próximamente en Chrome Web Store",
    apiKeySetup: "Configuración de clave API",
    apiKeyDescription:
      "La extensión requiere una clave API para conectarse a tu cuenta. Genera una a continuación e ingrésala en la configuración de la extensión.",
    yourApiKey: "Tu clave API",
    active: "Activa",
    hideApiKey: "Ocultar clave API",
    showApiKey: "Mostrar clave API",
    copyToClipboard: "Copiar al portapapeles",
    copiedToClipboard: "✓ ¡Copiado al portapapeles!",
    generateNewKey: "Generar nueva clave",
    regenerateKey: "Regenerar clave",
    deactivateKey: "Desactivar clave",
    created: "Creada",
    lastUsed: "Último uso",
    never: "Nunca",
    generateApiKey: "Generar clave API",
    noApiKey: "Sin clave API",
    noApiKeyDescription:
      "Aún no tienes una clave API activa. Genera una para comenzar a usar la extensión de Chrome.",
    generateFirst: "Genera tu primera clave API",
    confirmDeactivate:
      "¿Estás seguro de que quieres desactivar tu clave API? Esto revocará el acceso para la extensión de Chrome.",
    keyDeactivated: "La clave API ha sido desactivada exitosamente.",
    generateFailed: "Error al generar la clave API. Inténtalo de nuevo.",
    deactivateFailed: "Error al desactivar la clave API. Inténtalo de nuevo.",
    copyFailed:
      "Error al copiar al portapapeles. Por favor selecciona y copia la clave API manualmente.",
    deactivating: "Desactivando...",
    noApiKeyFound: "No se encontró clave API",
    generateApiKeyDescription:
      "Genera una clave API para conectar la extensión a tu cuenta.",
    generating: "Generando...",
    setupInstructions: "Instrucciones de configuración",
    instruction1:
      "Descarga e instala la extensión DealHawk de Chrome desde la Web Store",
    instruction2: "Genera una clave API usando la sección de arriba",
    instruction3: "Copia tu clave API al portapapeles",
    instruction4: "Abre la extensión y pega tu clave API en la configuración",
    instruction5:
      "Comienza a buscar productos directamente desde cualquier página web",
  },

  // Favorites
  favorites: {
    title: "Mis guardados",
    description: "Productos que has guardado para fácil acceso",
    noFavorites: "Aún no hay guardados",
    noFavoritesMessage:
      "Comienza agregando productos a tus guardados para verlos aquí.",
    addToFavorites: "Agregar a guardados",
    removeFromFavorites: "Quitar de guardados",
    viewProduct: "Ver producto",
    browseProducts: "Explorar productos",
    loadingFavorites: "Cargando tus guardados...",
    failedToLoadFavorites: "Error al cargar guardados",
    favoriteProductsFromStores:
      "productos guardados de tus tiendas seleccionadas",
    favoriteProductFromStores: "producto guardado de tus tiendas seleccionadas",
    tableHeaders: {
      product: "Producto",
      bestPrice: "Mejor Precio",
      msrp: "Precio de Lista",
      stockStatus: "Estado de Stock",
      actions: "Acciones",
    },
    noPricing: "Sin precio",
    percentOff: "% DESC",
    inStock: "En Stock",
    outOfStock: "Sin Stock",
    stores: "tiendas",
    removeFavoriteTooltip: "Quitar de guardados",
    loadingMore: "Cargando más...",
    loadMore: "Cargar Más",
    exportOptions: "Opciones de Exportación",
    downloadCSV: "Descargar CSV",
  },

  // Alertas
  tracking: {
    title: "Alertas de productos",
    description:
      "Configura alertas para cambios de precio y disponibilidad de tus productos favoritos",
    noTracking: "No hay productos con alertas",
    noTrackingMessage:
      "Comienza configurando alertas en productos para monitorear sus precios y disponibilidad.",
    addTracking: "Agregar alerta",
    removeTracking: "Quitar alerta",
    priceAlert: "Alerta de precio",
    priceDropAlert: "Alerta de bajada de precio",
    backInStock: "De vuelta en stock",
    // New translations for TracksPage
    loadingUserData: "Cargando datos del usuario...",
    loadingTracking: "Cargando alertas...",
    errorLoadingTracking: "Error al cargar alertas",
    failedToLoadTracking: "Error al cargar alertas",
    tryAgain: "Intentar de nuevo",
    trackingCount: "alertas",
    noTrackedProducts: "No hay productos con alertas",
    noTrackedProductsMessage:
      "Comienza configurando alertas en productos haciendo clic en el botón de alerta en cualquier producto en la página de Productos",
    trackedProducts: "Productos con Alertas",
    howItWorksDescription:
      "Configura alertas en productos para cambios de precio y recibe notificaciones de Discord cuando alcancen tu precio objetivo. Los productos se verifican periódicamente en todas las tiendas que tienes configuradas, y serás alertado cuando se encuentren ofertas. Puedes configurar alertas en hasta {{limit}} productos a la vez.",
    configureNotifications: "Configura tus preferencias de notificación en",
    settings: "Configuración",
    upcLabel: "UPC:",
    currentPrice: "Precio Actual",
    targetPrice: "Precio Objetivo",
    potentialSavings: "Ahorros Potenciales",
    targetReached: "¡Objetivo alcanzado!",
    trackingStatus: "Alertas activas...",
    lastChecked: "Última verificación:",
    minutesAgo: "hace {{minutes}} minutos",
    hoursAgo: "hace {{hours}} horas",
    daysAgo: "hace {{days}} días",
    manuallyUpdateTooltip: "Actualizar manualmente los datos del producto",
    removeTrackingTooltip: "Quitar alerta",
    update: "Actualizar",
    remove: "Quitar",
    exportOptions: "Opciones de Exportación",
    downloadCSV: "Descargar CSV",
  },

  // Configuration
  config: {
    title: "Configuración",
    description: "Configura tus preferencias de búsqueda de ofertas",
    filters: "Filtros",
    stores: "Tiendas",
    categories: "Categorías",
    searchTerms: "Términos de búsqueda",
    priceRange: "Rango de precios",
    discountThreshold: "Umbral de descuento",
    saveConfiguration: "Guardar configuración",
  },

  // Notifications
  notifications: {
    success: "Éxito",
    error: "Error",
    warning: "Advertencia",
    info: "Información",
    saved: "Guardado exitosamente",
    deleted: "Eliminado exitosamente",
    updated: "Actualizado exitosamente",
    created: "Creado exitosamente",
    failed: "Operación fallida",
    tryAgain: "Por favor, inténtalo de nuevo",
  },

  // Errors
  errors: {
    genericError: "Algo salió mal. Por favor, inténtalo de nuevo.",
    networkError: "Error de red. Por favor, verifica tu conexión.",
    serverError: "Error del servidor. Por favor, inténtalo más tarde.",
    notFound: "No encontrado",
    unauthorized: "Acceso no autorizado",
    forbidden: "Acceso prohibido",
    validationError: "Por favor, verifica tu entrada",
    emailRequired: "El correo electrónico es requerido",
    passwordRequired: "La contraseña es requerida",
    nameRequired: "El nombre es requerido",
    passwordsNoMatch: "Las contraseñas no coinciden",
    passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
    invalidEmail:
      "Por favor, ingresa una dirección de correo electrónico válida",
    emailAlreadyExists: "Este correo electrónico ya está registrado",
    userNotFound: "Usuario no encontrado",
    incorrectPassword: "Contraseña incorrecta",
    pageNotFound: "Página no encontrada",
    pageNotFoundMessage:
      "¡Ups! La página que estás buscando no existe. Puede que haya sido movida, eliminada, o ingresaste la URL incorrecta.",
    goHome: "Ir al inicio",
    goBack: "Volver",
    needHelp: "¿Necesitas ayuda? Prueba estos:",
    helpCenter: "Centro de ayuda",
  },

  // Bot Filters
  botFilters: {
    title: "Filtros de compra",
    description:
      "Administra las categorías de productos en las que DealHawk vigila ofertas",
    chooseCategories: "Elegir Categorías",
    chooseCategoriesToMonitor: "Selecciona categorías para monitorear ofertas",
    searchCategories: "Buscar categorías...",
    selectAll: "Seleccionar Todo",
    clearAll: "Limpiar Todo",
    categoriesSelected: "{{count}} de {{total}} categorías seleccionadas",
    shown: "{{count}} mostradas",
    noCategoriesFound: "No se encontraron categorías",
    tryAdjustingSearchTerms: "Intenta ajustar tus términos de búsqueda",
    youHaveUnsavedChanges: "Tienes cambios sin guardar",
    saving: "Guardando...",
    saveChanges: "Guardar Cambios",
    botConfiguration: "Filtros de compra",
    manageProductCategories:
      "Administra las categorías de productos en las que DealHawk vigila ofertas",
    categoriesSelectedOf: "{{selected}} de {{total}} categorías seleccionadas",
    searchTermsAdded: "{{count}} términos de búsqueda agregados",
    editCategories: "Editar Categorías",
    changesAreSavedAutomatically: "Los cambios se guardan automáticamente",
    selectedCategories: "Categorías Seleccionadas",
    noCategoriesSelectedTitle: "No hay categorías seleccionadas",
    noCategoriesSelectedMessage:
      'Haz clic en "Editar Categorías" para comenzar a monitorear ofertas',
    clickEditCategoriesToStart:
      'Haz clic en "Editar Categorías" para comenzar a monitorear ofertas',
    addCategories: "Agregar Categorías",
    searchTerms: "Términos de Búsqueda",
    addSpecificKeywords:
      "Agrega palabras clave específicas para encontrar ofertas más allá de las categorías",
    addKeywordsToFindSpecific:
      "Agrega palabras clave para encontrar productos específicos más allá de tus categorías seleccionadas",
    searchTermsUsed: "{{used}} de {{limit}} términos de búsqueda utilizados",
    plan: "Plan {{plan}}",
    enterSearchTerm: "Ingresa un término de búsqueda",
    searchTermPlaceholder:
      "Ingresa un término de búsqueda (ej. 'PlayStation 5', 'iPhone', 'Nike')",
    noSearchTermsTitle: "No hay términos de búsqueda agregados",
    noSearchTermsMessage:
      "Agrega términos de búsqueda para encontrar ofertas de productos o marcas específicas",
    addSearchTermsDescription:
      "Agrega términos de búsqueda para encontrar ofertas de productos o marcas específicas",
    removeSearchTerm: "Eliminar término de búsqueda",
    loadingCategories: "Cargando categorías...",
    pleaseLoginToAccess:
      "Por favor, inicia sesión para acceder a los filtros de compra.",
    failedToLoadCategories:
      "Error al cargar categorías. Por favor, inténtalo de nuevo.",
    configurationSaved: "¡Configuración guardada!",
    configurationSavedMessage:
      "{{categoryCount}} {{categoryText}} y {{searchTermCount}} {{searchTermText}} de búsqueda seleccionados.",
    failedToSaveBotFilters:
      "Error al guardar los filtros de compra. Por favor, inténtalo de nuevo.",
    searchTermAlreadyExists: "Este término de búsqueda ya existe",
    searchTermLimitReached:
      "Solo puedes tener {{limit}} términos de búsqueda en el plan {{plan}}",
    savedJustNow: "Guardado ahora mismo",
    savedMinutesAgo: "Guardado hace {{minutes}} minutos",
    savedAt: "Guardado a las {{time}}",
    stores: "Tiendas",
    addStoresToMonitor: "Seleccionar tiendas para monitorear ofertas",
    addStoresToFindSpecific:
      "Agregar tiendas para monitorear ubicaciones específicas para ofertas y artículos de liquidación",
    storesUsed: "{{used}} de {{limit}} tiendas utilizadas",
    storesSelectedOf: "{{selected}} de {{limit}} tiendas seleccionadas",
    addStores: "Agregar Tiendas",
    noStoresSelectedTitle: "No hay tiendas seleccionadas",
    extraStoresTitle: "Tiendas extra",
    extraStoresDescription:
      "Tu plan incluye {{count}} tiendas extra cerca de las que elegiste. Las revisamos con las ofertas que encontramos en tiendas cercanas, y sus ofertas salen en Todas las tiendas. También puedes cambiarte a una cuando quieras.",
    extraStoresDescriptionWalmart:
      "Tu plan incluye {{count}} tiendas extra cerca de las que elegiste. Las revisamos a diario con un escaneo más ligero de liquidaciones, rollbacks y productos rebajados, y sus ofertas salen en Todas las tiendas. También puedes cambiarte a una cuando quieras.",
    extraStoresView: "Ver ofertas",
    noStoresSelectedMessage:
      "Agregar tiendas para monitorear ofertas en ubicaciones específicas",
    removeStore: "Remover tienda",
    storeMaxReached: "Límite de tiendas alcanzado",
    contactDiscordToUpgrade:
      "Contáctanos en Discord para actualizar tu plan para más tiendas",
    storeLimitReached:
      "Solo puedes tener {{limit}} tiendas en el plan {{plan}}",
    setupCategories: "Seleccionar Categorías",
    setupStores: "Seleccionar Tiendas",
    pleaseSelectAtLeastOneCategory:
      "Por favor selecciona al menos una categoría para continuar",
    pleaseSelectAtLeastOneStore:
      "Por favor selecciona al menos una tienda para continuar",
    pleaseCompleteAllSteps:
      "Por favor completa todos los pasos antes de finalizar la configuración",
    completeSetup: "Completar Configuración",
    forRetailer: "para {{retailer}}",
  },

  // Add Categories Modal
  addCategoriesModal: {
    title: "Agregar Categorías",
    searchPlaceholder: "Buscar categorías...",
    loadingCategories: "Cargando categorías...",
    noCategoriesFound: "No se encontraron categorías",
    noCategoriesAvailable: "No hay categorías disponibles",
    alreadyAdded: "Ya agregado",
    categoriesSelected: "{{count}} {{categoryText}} seleccionadas",
    category: "categoría",
    categories: "categorías",
    cancel: "Cancelar",
    addSelected: "Agregar Seleccionadas",
  },

  // Add Stores Modal
  addStoresModal: {
    title: "Seleccionar Tiendas",
    planLimitDescription:
      "Puedes seleccionar hasta {{limit}} tiendas con tu plan actual",
    searchZipPlaceholder:
      "Ingresa código postal de 5 dígitos para tiendas cercanas (radio de 50 millas)",
    searchGeneralPlaceholder: "Buscar por código postal, ciudad o dirección",
    nearbyStoresInfo:
      "Mostrando tiendas dentro de {{radius}} millas del código postal {{zipCode}}, ordenadas por distancia",
    limitReached: "Límite alcanzado",
    previous: "Anterior",
    next: "Siguiente",
    showingStores: "Mostrando {{start}}-{{end}} de {{total}} tiendas",
    selectedCount: "({{selected}}/{{limit}} seleccionadas)",
    noStoresFound: "No se encontraron tiendas",
    noStoresFoundZip:
      "No se encontraron tiendas para este código postal. Intenta con un código postal diferente.",
    noStoresFoundGeneral:
      "Intenta buscar con un término diferente o ingresa un código postal de 5 dígitos para encontrar tiendas cercanas",
    searchToGetStarted: "Busca tiendas para comenzar",
    searchInstructions:
      "Ingresa un código postal de 5 dígitos para encontrar tiendas dentro de 50 millas, o busca por ciudad/dirección",
    storeCountSelected: "{{count}} de {{limit}} tiendas seleccionadas",
    storeCountSelectedSingular: "{{count}} de {{limit}} tienda seleccionada",
    limitReachedWarning: "(Límite alcanzado)",
    cancel: "Cancelar",
    saveSelection: "Guardar Selección",
    address: "Dirección",
    zipCode: "Código Postal",
    storeId: "ID de Tienda",
    milesAway: "{{distance}} millas de distancia",
    zipLabel: "Código postal:",
    storeIdLabel: "ID de Tienda: #{{id}}",
    currentStore: "Tienda Actual",
    cannotRemove: "No se puede eliminar",
    loadingStores: "Buscando tiendas cerca de {{zipCode}}...",
    geocodingInProgress: "Buscando coordenadas y calculando distancias",
  },

  // Support
  support: {
    videoTutorials: "Video tutoriales",
    videoTutorialsDescription: "Videos cortos que muestran cómo usar cada función.",
    title: "Centro de Soporte",
    subtitle: "Estamos aquí para ayudarte a aprovechar al máximo DealHawk",
    emailSupport: "Soporte por Email",
    available247: "Disponible 24/7",
    contactEmailText: "Comunícate con nuestro equipo de soporte:",
    fastResponse: "Respuesta Rápida",
    responseTime: "Típicamente respondemos dentro de 24 horas",
    expertHelp: "Ayuda Experta",
    expertHelpDesc: "Nuestro equipo conoce DealHawk por dentro y por fuera",
    backToApp: "Volver a la Aplicación",
    searchPlaceholder: "Buscar temas de soporte",
    searchAriaLabel: "Buscar temas de soporte",
    clearSearchAriaLabel: "Borrar búsqueda",
    contactUsButton: "Contáctanos",
    popularTitle: "Preguntas populares",
    popularSubtitle: "Respuestas rápidas organizadas por función y página.",
    faq: {
      gettingStarted: {
        title: "Primeros pasos",
        description: "Inicio, registro, configuración, paywall y flujo de éxito.",
        q1: "¿Qué es DealHawk y cómo funciona?",
        a1:
          "DealHawk monitorea tiendas compatibles y muestra ofertas, cambios de inventario y bajadas de precio para que actúes rápido.",
        q2: "¿Cómo creo una cuenta?",
        a2:
          "Usa la página de Registro para crear una cuenta con email o continuar con Google o Discord.",
        q3: "¿Necesito verificar mi email?",
        a3:
          "Sí. Revisa tu bandeja de entrada para el código de verificación e introdúcelo en la página de Verificación.",
        q4: "¿Cómo elijo un plan durante la configuración?",
        a4:
          "Las páginas de Configuración y Paywall explican las diferencias de planes y te permiten elegir tiendas antes de pagar.",
        q5: "El pago se completó pero aún no tengo acceso a funciones.",
        a5:
          "Abre la página de Éxito o recarga la app y luego revisa Ajustes para confirmar tu plan.",
      },
      accountSecurity: {
        title: "Cuenta y seguridad",
        description:
          "Inicio de sesión, restablecimiento de contraseña, eliminación de cuenta y OAuth.",
        q1: "Olvidé mi contraseña. ¿Qué hago?",
        a1:
          "Ve a Olvidé mi contraseña y solicita un código, luego crea una nueva contraseña.",
        q2: "Mi código de restablecimiento no funciona.",
        a2:
          "Solicita un nuevo código y asegúrate de ingresar el más reciente en Restablecer contraseña.",
        q3: "¿Puedo iniciar sesión con Google o Discord?",
        a3:
          "Sí. Usa los botones de Google o Discord en Inicio de sesión o Registro.",
        q4: "¿Cómo elimino mi cuenta?",
        a4:
          "Abre la página de Eliminar cuenta y sigue los pasos de confirmación.",
        q5: "No veo el email de verificación.",
        a5:
          "Revisa spam o promociones y vuelve a enviar el código desde la página de Verificación.",
      },
      productSearchScanning: {
        title: "Búsqueda y escaneo de productos",
        description:
          "Búsqueda, escaneo de código de barras y resultados por tienda.",
        q1: "¿Qué puedo buscar?",
        a1:
          "Busca por nombre, UPC, SKU o pega la URL del tienda en la página de Búsqueda.",
        q2: "¿Cómo escaneo un código de barras o QR?",
        a2:
          "Usa el botón de escaneo en Búsqueda para abrir la cámara y escanear el código.",
        q3: "¿Por qué no aparece mi producto?",
        a3:
          "Prueba otro tienda, confirma el UPC/SKU y asegúrate de que la tienda sea compatible.",
        q4: "¿Por qué la búsqueda tarda tanto?",
        a4:
          "Algunos tiendas tardan más en responder. Espera hasta 30 segundos y reintenta.",
        q5: "¿Puedo ver mis búsquedas recientes?",
        a5:
          "Sí. Búsqueda guarda una lista reciente y el historial para acceso rápido.",
      },
      productsFiltersCategories: {
        title: "Productos, filtros y categorías",
        description:
          "Filtros, ordenamiento y cambio de tienda en la página de Productos.",
        q1: "¿Cómo filtro productos por tienda o categoría?",
        a1:
          "Usa el menú de tienda y los filtros de categoría en Productos.",
        q2: "¿Cómo veo solo productos en stock o con caída de precio?",
        a2:
          "Usa filtros de estado como en stock, nuevo, caída de precio o guardado.",
        q3: "¿Qué son ofertas calientes y artículos de centavo?",
        a3:
          "Estos filtros destacan descuentos agresivos y artículos a precios mínimos.",
        q4: "¿Puedo ordenar por precio o última actualización?",
        a4: "Sí. Usa el menú de orden en Productos.",
        q5: "No veo productos después de filtrar.",
        a5:
          "Limpia o restablece los filtros y prueba una categoría o tienda más amplia.",
      },
      productDetailsAlerts: {
        title: "Detalles del producto y alertas",
        description: "Detalle de producto, seguimiento y alertas.",
        q1: "¿Cómo configuro una alerta de precio?",
        a1:
          "Abre un producto y toca Seguir o Alerta, luego define tu precio objetivo.",
        q2: "¿Qué significa Listo vs Vigilando en alertas?",
        a2:
          "Listo significa que se alcanzó tu precio objetivo. Vigilando significa que aún está por encima.",
        q3: "¿Puedo actualizar un seguimiento manualmente?",
        a3:
          "Sí. Usa la acción de actualizar en la nueva página de Alertas.",
        q4: "¿Cómo elimino una alerta?",
        a4:
          "Abre tu lista de alertas y elimina el seguimiento que ya no quieres.",
        q5: "¿Puedo exportar mis alertas?",
        a5:
          "La página de Alertas heredada incluye exportación CSV.",
      },
      leadsDealDiscovery: {
        title: "Leads y descubrimiento de ofertas",
        description: "Página de leads y acciones de ofertas.",
        q1: "¿Qué son los leads?",
        a1:
          "Los leads son oportunidades de ofertas curadas con precio y contexto de tienda.",
        q2: "¿Cómo guardo un lead?",
        a2:
          "Usa la acción de guardar en un lead para añadirlo a favoritos.",
        q3: "¿Puedo crear una alerta desde un lead?",
        a3:
          "Sí. Usa la acción de alerta para seguir cambios de precio.",
        q4: "¿Cómo reviso el stock de tienda desde un lead?",
        a4:
          "Usa el botón de Ver stock para ver disponibilidad.",
      },
      specialtyPages: {
        title: "Páginas especiales",
        description: "Woot y Penny Items Pro.",
        q1: "¿Qué es Penny Items Pro?",
        a1:
          "Es una página enfocada en artículos de precio ultra bajo, a menudo según reglas de tienda.",
        q2: "¿Qué es la página de Woot?",
        a2: "Destaca ofertas de Woot cuando están disponibles.",
      },
      settingsBillingNotifications: {
        title: "Ajustes, facturación y notificaciones",
        description: "Ajustes y filtros de compra.",
        q1: "¿Cómo cambio o cancelo mi suscripción?",
        a1:
          "Ve a Ajustes y abre Facturación para administrar tu plan.",
        q2: "¿Cómo vinculo Discord para notificaciones?",
        a2:
          "Abre Ajustes y conecta tu cuenta de Discord en Notificaciones.",
        q3: "¿Por qué solo puedo seleccionar un número limitado de tiendas?",
        a3:
          "Los límites dependen de tu plan y se configuran en Filtros de compra.",
      },
      helpContactLegal: {
        title: "Ayuda, contacto y legal",
        description: "Ayuda, Contacto, Soporte, Términos y Privacidad.",
        q1: "¿Cómo contacto soporte?",
        a1:
          "Usa el email en Soporte o únete al Discord desde Ayuda.",
        q2: "¿Dónde puedo enviar un ticket de soporte?",
        a2:
          "Únete al Discord y sigue los pasos en Ayuda para abrir un ticket.",
        q3: "¿Dónde puedo leer los Términos o la Política de Privacidad?",
        a3:
          "Abre las páginas de Términos de servicio o Política de privacidad desde el pie.",
        q4: "¿Por qué veo una página de No encontrado?",
        a4:
          "La página no existe o el enlace está desactualizado. Vuelve al inicio.",
      },
    },
  },

  // Success Page
  success: {
    paymentSuccessful: "¡Pago Exitoso!",
    thankYou: "Gracias por tu compra. Tu cuenta ha sido actualizada.",
    redirecting: "Redirigiendo al panel en",
    second: "segundo",
    seconds: "segundos",
    goToDashboard: "Ir al Panel Ahora",
    supportMessage:
      "Si tienes alguna pregunta, por favor contacta a nuestro equipo de soporte.",
  },
  // Reseller landing page ("/")
  resellerLanding: {
    navLabel: "Principal",
    navHow: "Cómo funciona",
    navHauls: "Compras",
    navPricing: "Precios",
    navFaq: "Preguntas",
    logIn: "Iniciar sesión",
    getStarted: "Empieza a cazar",
    heroTitle: "Caza liquidaciones. Revéndelas con ganancia.",
    heroLede: "La app para revendedores que cazan liquidaciones. Cada rebaja en las tiendas cerca de ti, cuántas quedan en el estante y en cuánto se revende en Amazon y eBay.",
    heroCta: "Empieza a cazar",
    heroHauls: "Ver lo que cazan los miembros",
    heroStores: "Caza en Walmart, Target, Costco, Dollar General y grandes tiendas",
    findsLabel: "Cacerías recientes de miembros",
    find1: "15 aspiradoras · $0.01",
    find2: "9 hieleras · $15",
    find3: "Un carrito de Milwaukee · $0.01",
    find4: "35 mangueras · $0.01",
    find5: "“Me llevé las 7” · 70% menos",
    find6: "Planchas · a mitad de precio",
    find7: "80 toallas · $1",
    bentoLabel: "Lo que DealHawk te muestra",
    resaleTitle: "Conoce tu ganancia antes de comprar",
    resaleText: "Ventas reales en Amazon y eBay, ya con comisiones, en cada hallazgo. ¿Te llevas las 12? La app hace la cuenta.",
    resaleAmazon: "Amazon +${{amount}}",
    resaleEbay: "eBay +${{amount}}",
    resaleExample: "Por unidad, ejemplo",
    resaleAlt: "Artículo de $50 con la ganancia por unidad en Amazon y eBay",
    alertsTitle: "El primero en la cacería",
    alertsBig: "Alertas al instante",
    alertsText: "Tu teléfono suena cuando una tienda rebaja algo.",
    stockLeft: "Quedan {{count}}",
    stockTitle: "Caza el estante completo",
    stockText: "Mira cuántas quedan y en qué pasillo. Llévatelas todas.",
    pennyWas: "Antes",
    pennyTitle: "Cazar centavos",
    pennyText: "Estantes completos rebajados a un centavo. Pura ganancia.",
    feedTitle: "Tu zona de caza",
    feedText: "Cada rebaja en tus tiendas, lo mejor primero.",
    feedAlt: "Lista de ofertas",
    cartAlt: "Carrito lleno de herramientas Milwaukee",
    cartCaption: "Un carrito de Milwaukee a $0.01 · cacería de un miembro",
    discordTitle: "Caza con otros revendedores",
    discordText: "Los miembros publican lo que encontraron, dónde y en cuánto lo vendieron.",
    stepsTitle: "Así cazan los revendedores con DealHawk",
    step1Title: "Te llega la alerta",
    step1Text: "Algo cerca de ti acaba de entrar en liquidación.",
    step2Title: "Ve por ello",
    step2Text: "Sabes el pasillo y cuántas quedan.",
    step3Title: "Revéndelo",
    step3Text: "Publícalo en eBay, Amazon o Marketplace.",
    step4Title: "Cobra",
    step4Text: "Compraste en liquidación, vendiste a precio normal. La ganancia es tuya.",
    haulsTitle: "Las mejores cacerías del mes",
    haul1Alt: "Aspiradoras",
    haul1Caption: "15 aspiradoras · $0.01 cada una",
    haul2Alt: "Hieleras",
    haul2Caption: "9 hieleras · $15 cada una",
    haul3Alt: "Mangueras",
    haul3Caption: "35 cajas de mangueras · $0.01",
    haul4Alt: "Pila de juegos de ollas Carote en la tienda",
    haul4Caption: "“70% menos. Me llevé las 7.”",
    faqTitle: "Lo que preguntan los revendedores",
    faq1Q: "¿Necesito experiencia?",
    faq1A: "No. Empieza a cazar en una tienda. La app te dice qué vale la pena revender y cuánto vas a ganar.",
    faq2Q: "¿Cuánto puedo ganar?",
    faq2A: "Depende de lo que caces y cuánto compres. La mayoría dice que una buena reventa paga el mes.",
    faq3Q: "¿Dónde venden los revendedores?",
    faq3A: "eBay, Amazon, Facebook Marketplace y grupos locales.",
    pricingTitle: "Una buena cacería paga el mes",
    planBasic: "1 tienda principal + 4 tiendas extra cercanas, en Walmart y en una de las grandes tiendas",
    planPlus: "Hasta 3 tiendas principales + 7 extra en Walmart y grandes tiendas, 9 cadenas, artículos a un centavo",
    planPro: "Hasta 5 tiendas principales + 15 extra en Walmart (10 en grandes tiendas), y a cuánto se revende cada artículo",
    pricingExplainer: "Las tiendas principales son las que tú eliges. Las tiendas extra cercanas son los Walmart y grandes tiendas más cerca de ellas, incluidas gratis con un escaneo diario más ligero de liquidaciones y rebajas.",
    pricingNote: "Al mes. 50% de descuento en tu primer mes.",
    closingTitle: "Mira qué está en liquidación cerca de ti.",
    examplePrices: "Precios de ejemplo en las pantallas de la app.",
    footerLabel: "Pie de página",
    languageLabel: "Idioma",
  },
};
